(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4893],{

/***/ 2627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toode/[toode]",
      function () {
        return __webpack_require__(9274);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Products; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4337);
/* harmony import */ var _UI_ProductCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(681);
/* harmony import */ var _UI_ProductCard_MobileProductCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1459);
/* harmony import */ var _UI_Skeletons_SkeletonProductCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3327);
/* harmony import */ var _UI_Skeletons_MobileSkeletonProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2298);
/* harmony import */ var hooks_products_useCatalogue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4457);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function Products(param) {
    var products = param.products;
    var items = products === null || products === void 0 ? void 0 : products.filter(function(item) {
        return item;
    });
    var numArray = _toConsumableArray(Array(24));
    var loading = (0,hooks_products_useCatalogue__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xuv, {
                display: {
                    _: "none",
                    desktop: "grid"
                },
                gridTemplateColumns: "repeat(3, 33.33%)",
                columnGap: "1rem",
                rowGap: "2rem",
                p: "1.5rem 1rem 0 0",
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: numArray.map(function(_, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Skeletons_SkeletonProductCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}, i);
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: items === null || items === void 0 ? void 0 : items.map(function(product) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_ProductCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            product: product,
                            imageSize: {
                                width: 180,
                                height: 200
                            }
                        }, product.sku);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xuv, {
                display: {
                    _: "grid",
                    desktop: "none"
                },
                gridTemplateColumns: {
                    _: "1fr",
                    lg_tablet: "1fr 1fr"
                },
                justifyItems: {
                    sm_tablet: "center"
                },
                columnGap: "0.75rem",
                rowGap: "0.1rem",
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: numArray === null || numArray === void 0 ? void 0 : numArray.map(function(_, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Skeletons_MobileSkeletonProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            // product={product}
                            maxW: 450,
                            minH: 150
                        }, i);
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: items === null || items === void 0 ? void 0 : items.map(function(product) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_ProductCard_MobileProductCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            product: product,
                            maxW: 450,
                            minH: 150
                        }, product.sku);
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 3862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CatalogueContainer; },
/* harmony export */   "O": function() { return /* binding */ ResultsContainer; }
/* harmony export */ });
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5653);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 224px;\n\n  .filter {\n    display: inline-flex;\n    align-items: center;\n\n    svg {\n      transform: scale(1.5);\n    }\n  }\n\n  @media (max-width: desktop) {\n    padding: 0 1rem;\n\n    h3 span {\n      display: none;\n    }\n  }\n\n  @media (min-width: desktop) {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  margin-top: 1rem;\n\n  @media (min-width: desktop) {\n    width: 72%;\n    margin-top: 3rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CatalogueContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].section */ .ZPm.section(_templateObject());
var ResultsContainer = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZPm)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_0__/* .FlexBox */ .h)(_templateObject1());


/***/ }),

/***/ 2524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BreadCrumbs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4337);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5653);
/* harmony import */ var _UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1028);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n\n  a {\n    color: #959595;\n    &:hover {\n      color: gray-300;\n    }\n  }\n\n  span {\n    position: relative;\n    bottom: 0.2rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Crumbs = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZPm)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_2__/* .FlexBox */ .h)(_templateObject());
function BreadCrumbs(param) {
    var crumbs = param.crumbs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
        display: {
            _: "none",
            desktop: "inline"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Crumbs, {
                spaceX: 10,
                children: crumbs === null || crumbs === void 0 ? void 0 : crumbs.map(function(crumb, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
                        spaceX: 10,
                        children: [
                            i > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                role: "img",
                                "aria-label": "Sequence arrow",
                                children: SequenceArrow
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: crumb.path,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: crumb.name
                                })
                            })
                        ]
                    }, crumb.path);
                })
            })
        })
    });
};
var SequenceArrow = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9.114",
    height: "4.48",
    viewBox: "0 0 9.114 4.48",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        id: "Icon_awesome-long-arrow-alt-right",
        "data-name": "Icon awesome-long-arrow-alt-right",
        d: "M6.387,11.684H.244A.244.244,0,0,0,0,11.929v1.139a.244.244,0,0,0,.244.244H6.387v.937a.488.488,0,0,0,.834.345l1.751-1.751a.488.488,0,0,0,0-.691L7.22,10.4a.488.488,0,0,0-.834.345Z",
        transform: "translate(0 -10.258)",
        fill: "#959595"
    })
});


/***/ }),

/***/ 7115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4337);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7248);
/* harmony import */ var _UI_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1040);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 1rem 0.75rem 0.5rem;\n  resize: none;\n  outline: 0;\n  border: 1.6px solid ",
        ";\n  border-radius: 7px;\n\n  &:focus {\n    border: 1.6px solid gray;\n  }\n\n  @media (min-width: tablet) {\n    width: 80%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledTextarea = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].textareaBox */ .ZPm.textareaBox(_templateObject(), _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__.th.color("purple-200"));
var Textarea = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xuv, {
        w: "100%",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTextarea, _objectSpread({
                ref: ref,
                rows: "5",
                placeholder: props.placeholder,
                value: props.value,
                onChange: props.onChange,
                borderColor: props.error && "#e54f4f"
            }, props)),
            props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_utils__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                children: props.error.message
            })
        ]
    });
});
Textarea.displayName = "Textarea";
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 7184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CarouselArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);


function CarouselArrow(param) {
    var onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        as: "span",
        role: "button",
        "aria-label": "Arrow for toggling between slides",
        onClick: onClick,
        children: children
    });
};


/***/ }),

/***/ 681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9926);
/* harmony import */ var utils_getProductImage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7883);
/* harmony import */ var _DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4522);
/* harmony import */ var _UI_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9696);
/* harmony import */ var _UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1028);
/* harmony import */ var _UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5618);
/* harmony import */ var _UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9565);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4567);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










/**
 * ProductCard
 *
 * Generic product card component
 *
 * @prop {object} product - object of a single product
 * @prop {object} imageSize - object of image width and height {width, height}
 * @prop {object} badges - object of badges to show/hide with custom content
 * @prop {boolean} hideRating - to toggle if rating is hidden
 * @prop {float} scale - image transform scale
 * @prop {float} hoverScale - image transform scale on hover
 */ function ProductCard(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var price = (0,hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((ref = props.product) === null || ref === void 0 ? void 0 : ref.price_range);
    var image = (0,utils_getProductImage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        mainImage: props.product.image,
        gallery: props.product.media_gallery
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductCardBox */ .Ps, _objectSpread({}, props, {
        hoverScale: props.hoverScale,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/toode/[toode]",
                as: "/toode/".concat(props.product.url_key),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    children: [
                        !props.hideRating && ((ref1 = props.product) === null || ref1 === void 0 ? void 0 : ref1.rating_summary) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            rating: (ref2 = props.product) === null || ref2 === void 0 ? void 0 : ref2.rating_summary,
                            flexDirection: "column",
                            position: "absolute",
                            right: props.scale ? "0.35rem" : "0.6rem",
                            top: props.scale ? "0.25rem" : "0.5rem"
                        }) : null,
                        (price === null || price === void 0 ? void 0 : (ref3 = price.discount) === null || ref3 === void 0 ? void 0 : ref3.value) && ((ref4 = props.badges) === null || ref4 === void 0 ? void 0 : ref4.discount) || ((ref5 = props.badges) === null || ref5 === void 0 ? void 0 : ref5.discount.text) === "Lemmik" || ((ref6 = props.badges) === null || ref6 === void 0 ? void 0 : ref6.discount.text) === "Favourite" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            id: "discount_badge",
                            children: props.badges.discount.text || "Soodus"
                        }) : null,
                        (price === null || price === void 0 ? void 0 : (ref7 = price.discount) === null || ref7 === void 0 ? void 0 : ref7.percentNumber) > 0 && !((ref8 = props.badges) === null || ref8 === void 0 ? void 0 : ref8.discount) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            percent: "-" + Math.round(Number(price === null || price === void 0 ? void 0 : (ref9 = price.discount) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.percent) === null || ref10 === void 0 ? void 0 : ref10.replace("-", "").replace(" ", "").replace("kuni", "").replace("%", ""))) + "%"
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            src: image === null || image === void 0 ? void 0 : image.url,
                            alt: image === null || image === void 0 ? void 0 : image.label,
                            width: props.imageSize.width,
                            height: props.imageSize.height,
                            objectFit: "contain"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductTitle */ .tc, {
                            scale: props.scale,
                            children: (ref11 = props.product) === null || ref11 === void 0 ? void 0 : ref11.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductPrice */ .jF, {
                            scale: props.scale,
                            children: [
                                (price === null || price === void 0 ? void 0 : (ref12 = price.discount) === null || ref12 === void 0 ? void 0 : ref12.value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: price === null || price === void 0 ? void 0 : (ref13 = price.discount) === null || ref13 === void 0 ? void 0 : ref13.value
                                }) : null,
                                price === null || price === void 0 ? void 0 : price.value
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ButtonsContainer */ .YD, {
                spaceX: "1rem",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        product: props.product
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 4806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RatingScale; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4337);
/* harmony import */ var _Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5653);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1040);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem 0 2.5rem;\n  text-align: center;\n\n  span {\n    font-weight: 700;\n\n    &:nth-of-type(1) {\n      display: inline-block;\n      width: 1.8rem;\n      height: 1.8rem;\n      padding: 0.1rem;\n      border: 1.3px solid black;\n      border-radius: 50%;\n      font-weight: 700;\n\n      &:hover {\n        background-color: teal-100;\n        cursor: pointer;\n      }\n    }\n  }\n\n  input[type='radio'] {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Rate = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZPm)(_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_1__/* .FlexBox */ .h)(_templateObject());
function RatingScale(param) {
    var rating = param.rating, setRating = param.setRating, error = param.error;
    var theme = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .FgM)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Rate, {
                spaceX: {
                    _: "1.6rem",
                    sm_tablet: "3rem",
                    desktop: "4.2rem"
                },
                children: _toConsumableArray(Array(5)).map(function(_, i) {
                    var ratingValue = i + 1;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "radio",
                                name: "rating",
                                value: ratingValue,
                                onClick: function() {
                                    return setRating(ratingValue);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_1__/* .FlexColCenter */ .S, {
                                spaceY: "0.5rem",
                                position: "relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xuv, {
                                        as: "span",
                                        bg: ratingValue <= rating && theme.colors["teal-100"],
                                        children: ratingValue
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xuv, {
                                        as: "span",
                                        position: "absolute",
                                        top: "1.5rem",
                                        whiteSpace: {
                                            _: "wrap",
                                            mobile: "nowrap"
                                        },
                                        children: i === 0 ? "Pole rahul" : i === 4 ? "V\xe4ga rahul" : null
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                whiteSpace: "nowrap",
                children: error
            })
        ]
    });
};


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _SkeletonElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7810);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0.2rem 0.4rem 0.5rem;\n  border-radius: 12px;\n  border: 0.7px solid #d8d9e5;\n  background-color: white;\n  font-weight: 500;\n  margin-top: 2rem;\n  margin-right: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var MobileSkeletonProductCard = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MobileProductCardBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "mobileskeletonimage"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonInfo, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontitle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontitle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontext"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontext"
                    })
                ]
            })
        ]
    });
};
var MobileProductCardBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].divBox */ .ZPm.divBox(_templateObject());
var SkeletonInfo = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZPm.div(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (MobileSkeletonProductCard);


/***/ }),

/***/ 7810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8609);
/* harmony import */ var _Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1__);


var SkeletonElement = function(param) {
    var type = param.type;
    // const classes = `skeleton ${type}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1___default())[type]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonElement);


/***/ }),

/***/ 3327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _SkeletonElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7810);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  max-width: 270px;\n  padding: 0 1.25rem;\n  margin-right: 0.5rem;\n  border: 0.7px solid #d8d9e5;\n  border-radius: 12px;\n  background-color: white;\n  font-weight: 500;\n  height: 369.88px;\n  padding: '1rem 1rem 2rem';\n\n  @media (max-width: lg_tablet) {\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  padding-bottom: 15%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SkeletonProductCard = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonProductBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "skeletonproductimage"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonInfo, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontitle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontext"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontext"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonProductCard);
var SkeletonProductBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].divBox */ .ZPm.divBox(_templateObject());
var SkeletonInfo = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZPm.div(_templateObject1());


/***/ }),

/***/ 1642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useModal() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isShown = ref[0], setIsShown = ref[1];
    var toggle = function() {
        return setIsShown(!isShown);
    };
    return {
        isShown: isShown,
        toggle: toggle
    };
};


/***/ }),

/***/ 4457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCatalogue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3359);
/* harmony import */ var jotai_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(561);
/* harmony import */ var graphql_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4462);
/* harmony import */ var utils_getCategoryId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4244);
/* harmony import */ var _useProductPages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8812);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function useCatalogue() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var lang = router.locale ? router.locale : "et";
    // Get category url slug
    var categorySlug = router.asPath.split("/").pop().split("?")[0];
    // Get category ID
    var id = (0,utils_getCategoryId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(categorySlug);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), productCount = ref6[0], setProductCount = ref6[1];
    var pageSize = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .pageSizeAtom */ .Gx);
    var currentPage = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .currentPageAtom */ .ef);
    var ref1 = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .sortAtom */ .xe), sortBy = ref1.value;
    var ref2 = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .filtersAtom */ .ot), price = ref2.price, brand = ref2.brand, v__rv = ref2.v__rv;
    // Prepare query variables
    var queryVariables = {
        id: id,
        price: price,
        brand: brand,
        v__rv: v__rv,
        sortBy: sortBy,
        currentPage: currentPage,
        pageSize: pageSize
    };
    // Get category products
    var ref3 = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_7__/* .useLazyQuery */ .t)(graphql_queries__WEBPACK_IMPORTED_MODULE_3__/* .CATEGORY_PRODUCTS */ .h$, {
        variables: queryVariables,
        context: {
            headers: {
                store: lang
            },
            fetchOptions: {
                method: "GET"
            }
        },
        fetchPolicy: "network-only",
        errorPolicy: "all",
        onCompleted: function(data) {
            var ref;
            var count = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.total_count;
            if (count && productCount !== count) {
                setProductCount(count);
            }
        }
    }), 2), getProducts = ref3[0], ref4 = ref3[1], data1 = ref4.data, loading = ref4.loading, error = ref4.error, called = ref4.called;
    var ref5 = (0,_useProductPages__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(getProducts, data1), products = ref5.products, pages = ref5.pages;
    return {
        products: products,
        loading: loading,
        pages: pages,
        count: productCount
    };
};


/***/ }),

/***/ 8812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductPages; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(561);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




function useProductPages(getProducts, data) {
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), products = ref4[0], setProducts = ref4[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), pages = ref1[0], setPages = ref1[1];
    var ref2 = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_2__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_1__/* .currentPageAtom */ .ef), 2), currentPage = ref2[0], setCurrentPage = ref2[1];
    // Execute products query upon page change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return getProducts();
    }, [
        currentPage
    ]);
    // Set products & pages
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.products) {
            var ref, ref3;
            setProducts(data === null || data === void 0 ? void 0 : data.products.items);
            var pageAmount = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : (ref3 = ref.page_info) === null || ref3 === void 0 ? void 0 : ref3.total_pages;
            if (pages !== pageAmount) {
                setPages(pageAmount);
            }
        }
    }, [
        data === null || data === void 0 ? void 0 : data.products
    ]);
    return {
        products: products,
        pages: pages
    };
};


/***/ }),

/***/ 9274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ProductPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./graphql/queries/index.js + 28 modules
var queries = __webpack_require__(4462);
;// CONCATENATED MODULE: ./lib/Google/events/viewProduct.gtag.js
function viewProductEvent(product) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var price = product === null || product === void 0 ? void 0 : (ref = product.price_range) === null || ref === void 0 ? void 0 : ref.maximum_price;
    return gtag("event", "view_item", {
        currency: "EUR",
        value: price === null || price === void 0 ? void 0 : (ref1 = price.final_price) === null || ref1 === void 0 ? void 0 : ref1.value,
        items: [
            {
                currency: "EUR",
                quantity: 1,
                item_id: product === null || product === void 0 ? void 0 : product.id,
                item_name: product === null || product === void 0 ? void 0 : product.name,
                item_brand: product === null || product === void 0 ? void 0 : (ref2 = product.mpbrand) === null || ref2 === void 0 ? void 0 : ref2.value,
                item_category: (ref3 = product === null || product === void 0 ? void 0 : product.categories[0]) === null || ref3 === void 0 ? void 0 : ref3.name,
                item_category2: (ref4 = product === null || product === void 0 ? void 0 : product.categories[1]) === null || ref4 === void 0 ? void 0 : ref4.name,
                item_category3: (ref5 = product === null || product === void 0 ? void 0 : product.categories[2]) === null || ref5 === void 0 ? void 0 : ref5.name,
                price: price === null || price === void 0 ? void 0 : (ref6 = price.final_price) === null || ref6 === void 0 ? void 0 : ref6.value,
                discount: price === null || price === void 0 ? void 0 : (ref7 = price.discount) === null || ref7 === void 0 ? void 0 : ref7.value
            }
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./hooks/products/useProductBreadcrumbs.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var mapQueryCrumbs = function(data) {
    var ref;
    var lastCategory = data[(data === null || data === void 0 ? void 0 : data.length) - 1 || 0];
    var prevCategories = lastCategory === null || lastCategory === void 0 ? void 0 : (ref = lastCategory.breadcrumbs) === null || ref === void 0 ? void 0 : ref.map(function(category) {
        return {
            name: category.category_name,
            path: category.category_url_key,
            level: category.category_level
        };
    });
    var lastCategoryCrumbs = {
        name: lastCategory === null || lastCategory === void 0 ? void 0 : lastCategory.name,
        path: lastCategory === null || lastCategory === void 0 ? void 0 : lastCategory.url_key,
        level: lastCategory === null || lastCategory === void 0 ? void 0 : lastCategory.level
    };
    if (!prevCategories) {
        prevCategories = [];
    }
    return _toConsumableArray(prevCategories && prevCategories).concat([
        lastCategoryCrumbs
    ]);
};
var mapProductCrumbs = function(data) {
    if (data.length > 0) {
        var levelTwo = data.find(function(param) {
            var level = param.level;
            return level === 2;
        });
        var levelThree = data.find(function(param) {
            var level = param.level;
            return level === 3;
        });
        var crumbs = data.map(function(crumb) {
            var path = "/kataloog";
            if (crumb.level === 2) {
                path += "/".concat(crumb.path);
            } else if (crumb.level === 3) {
                path += "/".concat(levelTwo === null || levelTwo === void 0 ? void 0 : levelTwo.path, "/").concat(crumb.path);
            } else if (crumb.level === 4) {
                path += "/".concat(levelTwo === null || levelTwo === void 0 ? void 0 : levelTwo.path, "/").concat(levelThree === null || levelThree === void 0 ? void 0 : levelThree.path, "/").concat(crumb.path);
            }
            return {
                name: crumb.name,
                path: path
            };
        });
        return crumbs;
    } else return null;
};
function useProductBreadcrumbs(product) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,next_router.useRouter)(), currentPath = ref.asPath;
    var ref1 = (0,react.useState)([]), queryCrumbs1 = ref1[0], setQueryCrumbs = ref1[1];
    var ref2 = (0,react.useState)([]), crumbs1 = ref2[0], setCrumbs = ref2[1];
    var ref3 = product || {}, name = ref3.name, categories = ref3.categories;
    (0,react.useEffect)(function() {
        if (categories) {
            var queryCrumbs = mapQueryCrumbs(categories);
            if (queryCrumbs) setQueryCrumbs(queryCrumbs);
        }
    }, [
        categories
    ]);
    (0,react.useEffect)(function() {
        var crumbs = mapProductCrumbs(queryCrumbs1);
        if (crumbs) {
            var breadcrumbs = [
                {
                    name: t("ui.home"),
                    path: "/"
                }
            ].concat(_toConsumableArray(crumbs), [
                {
                    name: name,
                    path: currentPath
                }
            ]);
            setCrumbs(breadcrumbs);
        }
    }, [
        queryCrumbs1
    ]);
    return crumbs1;
};

// EXTERNAL MODULE: ./components/SEO.js
var SEO = __webpack_require__(9831);
// EXTERNAL MODULE: ./components/UI/Layout/index.js
var Layout = __webpack_require__(3793);
// EXTERNAL MODULE: ./components/UI/Layout/Container.js
var Container = __webpack_require__(6094);
// EXTERNAL MODULE: ./components/UI/Breadcrumbs/index.js
var Breadcrumbs = __webpack_require__(2524);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var minimal_esm = __webpack_require__(9666);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var interweave_esm = __webpack_require__(3108);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var jotai_esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./utils/getProductPrice.js
var getProductPrice = __webpack_require__(5689);
;// CONCATENATED MODULE: ./hooks/products/useProductPrice.js
function useProductPrice_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || useProductPrice_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function useProductPrice_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useProductPrice_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useProductPrice_arrayLikeToArray(o, minLen);
}




function useProductPrice(prices) {
    var ref1 = _slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productPriceAtom */.XJ), 2), price = ref1[0], setPrice = ref1[1];
    (0,react.useEffect)(function() {
        var ref = (0,getProductPrice/* default */.Z)(prices), priceValue = ref.priceValue, discount = ref.discount;
        setPrice({
            value: priceValue,
            discount: discount
        });
    }, [
        prices
    ]);
    return price;
};

;// CONCATENATED MODULE: ./hooks/products/useColors.js
function useColors_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useColors_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useColors_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useColors_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useColors_slicedToArray(arr, i) {
    return useColors_arrayWithHoles(arr) || useColors_iterableToArrayLimit(arr, i) || useColors_unsupportedIterableToArray(arr, i) || useColors_nonIterableRest();
}
function useColors_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useColors_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useColors_arrayLikeToArray(o, minLen);
}


function useColors(product) {
    var ref = product || {}, variants = ref.variants, configurable_options = ref.configurable_options;
    var ref1 = useColors_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productVariantsAtom */.CA), 1), selectedVariants = ref1[0];
    var selectedCustomVariant = function(attr) {
        return selectedVariants === null || selectedVariants === void 0 ? void 0 : selectedVariants.find(function(selected) {
            return (selected === null || selected === void 0 ? void 0 : selected.attribute) === "custom" && (selected === null || selected === void 0 ? void 0 : selected.uid) === attr.uid;
        });
    };
    var hasColorOption = configurable_options && configurable_options.some(function(option) {
        return option.attribute_code === "v__rv";
    });
    var variantsInStock = variants && variants.slice().sort(function(a, b) {
        return a.attributes[0].label.localeCompare(b.attributes[0].label);
    });
    var colorsInStock = variantsInStock && variantsInStock.filter(function(variant) {
        return variant.attributes.some(function(attr) {
            return selectedCustomVariant(attr);
        });
    });
    var colors = (configurable_options === null || configurable_options === void 0 ? void 0 : configurable_options.length) > 1 ? colorsInStock : variantsInStock;
    var showColors = hasColorOption && ((configurable_options === null || configurable_options === void 0 ? void 0 : configurable_options.length) === 1 || (selectedVariants === null || selectedVariants === void 0 ? void 0 : selectedVariants.length) > 0);
    return {
        showColors: showColors,
        colors: colors
    };
};

// EXTERNAL MODULE: ./hooks/cart/useAddToCart.js + 3 modules
var useAddToCart = __webpack_require__(4688);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.mjs
var YouTube = __webpack_require__(3191);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/mousewheel/mousewheel.js
var mousewheel = __webpack_require__(4224);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(2997);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/thumbs/thumbs.js
var thumbs = __webpack_require__(732);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(4002);
// EXTERNAL MODULE: ./node_modules/@xstyled/system/dist/system.esm.js
var system_esm = __webpack_require__(7248);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./hooks/UI/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(2291);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
;// CONCATENATED MODULE: ./components/Product/ImageCarousel/Gallery.js
function Gallery_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Gallery_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Gallery_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Gallery_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Gallery_slicedToArray(arr, i) {
    return Gallery_arrayWithHoles(arr) || Gallery_iterableToArrayLimit(arr, i) || Gallery_unsupportedIterableToArray(arr, i) || Gallery_nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Gallery_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Gallery_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gallery_arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 1rem 1rem 2rem;\n\n  span {\n    position: absolute;\n    top: 1.5rem;\n    right: 0.5rem;\n    z-index: 11;\n    cursor: pointer;\n\n    @media (min-width: desktop) {\n      top: 2rem;\n      right: 3rem;\n\n      svg {\n        transform: scale(1.5);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  cursor: pointer;\n\n  @media (max-width: desktop) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Lightbox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1921).then(__webpack_require__.bind(__webpack_require__, 1921));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1921)
            ];
        }
    }
});
var Header = styled_components_esm/* default.div */.ZPm.div(_templateObject());
var Arrow = styled_components_esm/* default.spanBox */.ZPm.spanBox(_templateObject1());
function Gallery(param) {
    var images = param.images;
    var galleryImages = images === null || images === void 0 ? void 0 : images.map(function(img) {
        return {
            src: img.url,
            alt: img.label
        };
    });
    var theme = (0,styled_components_esm/* useTheme */.FgM)();
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var ref = Gallery_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* lightboxAtom */.fo), 2), isLightboxOpen = ref[0], setLightboxOpen = ref[1];
    var ref1 = Gallery_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* currentGalleryIndexAtom */.N2), 2), currentIndex = ref1[0], setCurrentIndex = ref1[1];
    var goToPrev = function() {
        return currentIndex > 0 && setCurrentIndex(currentIndex - 1);
    };
    var goToNext = function() {
        return currentIndex + 1 < galleryImages.length && setCurrentIndex(currentIndex + 1);
    };
    (0,useLockBodyScroll/* default */.Z)(isLightboxOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightbox, {
        images: galleryImages,
        isOpen: isLightboxOpen,
        currentIndex: currentIndex,
        onPrev: goToPrev,
        onNext: goToNext,
        onClose: function() {
            return setLightboxOpen(false);
        },
        singleClickToZoom: true,
        style: {
            background: theme.colors["gray-300"],
            padding: viewportWidth < 1024 && "0 1rem"
        },
        renderHeader: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "button",
                    "aria-label": "Close image gallery",
                    onClick: function() {
                        return setLightboxOpen(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Close */.x8, {})
                })
            });
        },
        renderPrevButton: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: currentIndex > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                    role: "button",
                    "aria-label": "Go to previous image",
                    left: "2rem",
                    onClick: goToPrev,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowLeft */.wT, {
                        strokeWidth: 4
                    })
                })
            });
        },
        renderNextButton: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: currentIndex + 1 < galleryImages.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                    role: "button",
                    "aria-label": "Go to next image",
                    right: "2rem",
                    onClick: goToNext,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowRight */.C$, {
                        strokeWidth: 4
                    })
                })
            });
        },
        pageTransitionConfig: {
            from: {
                opacity: 0
            },
            enter: {
                opacity: 1
            },
            leave: {
                opacity: 0
            },
            config: {
                mass: 1,
                tension: 320,
                friction: 32
            }
        }
    });
};

// EXTERNAL MODULE: ./components/UI/Image/index.js
var Image = __webpack_require__(9696);
;// CONCATENATED MODULE: ./components/Product/ImageCarousel/Slider.js
function Slider_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Slider_templateObject() {
    var data = Slider_taggedTemplateLiteral([
        "\n  display: flex;\n  max-width: 520px;\n  padding-top: 3rem;\n\n  .swiper-slide {\n    cursor: pointer;\n  }\n\n  @media (max-width: desktop) {\n    display: none;\n  }\n"
    ]);
    Slider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Slider_templateObject1() {
    var data = Slider_taggedTemplateLiteral([
        "\n  flex: 1;\n  max-height: 400px;\n  margin: -2rem 0 0 5rem;\n  padding-bottom: 1.5rem;\n\n  .swiper-pagination {\n    bottom: 0;\n  }\n\n  .swiper-pagination-bullet-active {\n    background-color: teal-300;\n  }\n"
    ]);
    Slider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Slider_taggedTemplateLiteral([
        "\n  margin-top: 2.5rem;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Slider_taggedTemplateLiteral([
        "\n      display: none;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = Slider_taggedTemplateLiteral([
        "\n  max-height: 290px;\n\n  .swiper-slide-active {\n    border: 0.7px solid ",
        ";\n    border-radius: 5px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










core_class/* default.use */.Z.use([
    mousewheel/* default */.Z,
    pagination/* default */.Z,
    thumbs/* default */.Z
]);
var GalleryContainer = styled_components_esm/* default.div */.ZPm.div(Slider_templateObject());
var MainThumb = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(Slider_templateObject1());
var VideoContainer = styled_components_esm/* default.div */.ZPm.div(_templateObject2());
var SmallThumbs = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(_templateObject4(), system_esm.th.color("purple-100"), function(param) {
    var hide = param.hide;
    return hide && (0,styled_components_esm/* css */.ivY)(_templateObject3());
});
function ImageSlider(param) {
    var images = param.images, product = param.product;
    var sliderRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), thumbsSlider = ref[0], setThumbsSlider = ref[1];
    var setCurrentIndex = (0,jotai_esm/* useSetAtom */.b9)(store/* currentGalleryIndexAtom */.N2);
    var setLightboxOpen = (0,jotai_esm/* useSetAtom */.b9)(store/* lightboxAtom */.fo);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GalleryContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallThumbs, {
                        ref: sliderRef,
                        onSwiper: setThumbsSlider,
                        direction: "vertical",
                        slidesPerView: 3,
                        spaceBetween: 16,
                        loop: (images === null || images === void 0 ? void 0 : images.length) > 3 && true,
                        hide: (images === null || images === void 0 ? void 0 : images.length) === 1 ? 1 : null,
                        mousewheel: {
                            sensitivity: 500
                        },
                        watchSlidesProgress: true,
                        children: images === null || images === void 0 ? void 0 : images.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                                    w: 80,
                                    p: 8,
                                    onClick: function() {
                                        setCurrentIndex(i);
                                        sliderRef.current.swiper.slideToLoop(i);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: item.url,
                                        alt: item.label || product,
                                        width: 80,
                                        height: 80
                                    })
                                })
                            }, item.url);
                        })
                    }),
                    (images === null || images === void 0 ? void 0 : images.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainThumb, {
                        thumbs: {
                            swiper: thumbsSlider
                        },
                        pagination: {
                            clickable: true,
                            dynamicBullets: true,
                            dynamicMainBullets: 3
                        },
                        loop: true,
                        children: images.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                onClick: function() {
                                    setCurrentIndex(i);
                                    setLightboxOpen(true);
                                },
                                children: item.video_content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube/* default */.Z, {
                                        videoId: item.video_content.video_url.split("v=")[1],
                                        opts: {
                                            height: "290px",
                                            width: "100%",
                                            borderRadius: "4px",
                                            autoplay: 0,
                                            playerVars: {
                                                autoplay: 0
                                            }
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: item.url,
                                    alt: item.label || product,
                                    width: 360,
                                    height: 360
                                })
                            }, item.url);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        ml: 112,
                        cursor: "pointer",
                        onClick: function() {
                            return setLightboxOpen(true);
                        },
                        children: images === null || images === void 0 ? void 0 : images.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: item.url,
                                alt: item.label || product,
                                width: 360,
                                height: 360
                            }, item.url);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                images: images
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/utils.js
var utils = __webpack_require__(1040);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
;// CONCATENATED MODULE: ./components/Product/ImageCarousel/Swiper.js
function Swiper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Swiper_templateObject() {
    var data = Swiper_taggedTemplateLiteral([
        "\n  margin-top: 4rem;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Swiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Swiper_templateObject1() {
    var data = Swiper_taggedTemplateLiteral([
        "\n  .swiper-container {\n    padding-bottom: 3rem;\n  }\n"
    ]);
    Swiper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Swiper_templateObject2() {
    var data = Swiper_taggedTemplateLiteral([
        "\n  .swiper-slide {\n    ",
        ";\n  }\n\n  .swiper-pagination {\n    margin-left: -1rem;\n  }\n\n  .swiper-pagination-bullet-active {\n    background-color: teal-300;\n  }\n"
    ]);
    Swiper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












core_class/* default.use */.Z.use([
    pagination/* default */.Z
]);
var Swiper_VideoContainer = styled_components_esm/* default.div */.ZPm.div(Swiper_templateObject());
var SwiperContainer = styled_components_esm/* default.div */.ZPm.div(Swiper_templateObject1());
var StyledSwiper = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(Swiper_templateObject2(), utils/* FlexCenter */.Lb);
function ImageSwiper(param) {
    var images = param.images, product = param.product;
    var swiperRef = (0,react.useRef)(null);
    var setCurrentIndex = (0,jotai_esm/* useSetAtom */.b9)(store/* currentGalleryIndexAtom */.N2);
    var setLightboxOpen = (0,jotai_esm/* useSetAtom */.b9)(store/* lightboxAtom */.fo);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
        children: [
            (images === null || images === void 0 ? void 0 : images.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
                    ref: swiperRef,
                    slidesPerView: 1,
                    loop: true,
                    observer: true,
                    pagination: {
                        dynamicBullets: true,
                        dynamicMainBullets: 3
                    },
                    children: images === null || images === void 0 ? void 0 : images.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            onClick: function() {
                                setCurrentIndex(i);
                                setLightboxOpen(true);
                            },
                            children: item.video_content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Swiper_VideoContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube/* default */.Z, {
                                    videoId: item.video_content.video_url.split("v=")[1],
                                    opts: {
                                        height: "210px",
                                        width: "100%",
                                        playerVars: {
                                            autoplay: 0
                                        },
                                        controls: 0
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: item.url,
                                    alt: item.label || product,
                                    width: 360,
                                    height: 360
                                })
                            })
                        }, item.url);
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                align: "center",
                justify: "center",
                onClick: function() {
                    return setLightboxOpen(true);
                },
                children: images === null || images === void 0 ? void 0 : images.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: item.url,
                        alt: item.label || product,
                        width: 360,
                        height: 360
                    }, item.url);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                images: images
            })
        ]
    });
};

;// CONCATENATED MODULE: ./utils/mapProductVariantAttributes.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function mapProductVariantAttributes(variant) {
    var ref;
    var _product = variant.product, id = _product.id, sku = _product.sku, img = _product.image, media_gallery = _product.media_gallery, attributes = variant.attributes;
    var colorAttribute = attributes === null || attributes === void 0 ? void 0 : attributes.filter(function(attribute) {
        return attribute.code === "v__rv";
    })[0];
    var color = colorAttribute === null || colorAttribute === void 0 ? void 0 : colorAttribute.label;
    var colorUID = colorAttribute === null || colorAttribute === void 0 ? void 0 : colorAttribute.uid;
    var image = {
        label: img === null || img === void 0 ? void 0 : img.label
    };
    if ((img === null || img === void 0 ? void 0 : (ref = img.url) === null || ref === void 0 ? void 0 : ref.includes("placeholder")) && (media_gallery === null || media_gallery === void 0 ? void 0 : media_gallery.length)) {
        var ref1;
        image = _objectSpread({}, img, {
            url: (ref1 = media_gallery[0]) === null || ref1 === void 0 ? void 0 : ref1.url
        });
    } else {
        image = _objectSpread({}, img, {
            url: img === null || img === void 0 ? void 0 : img.url
        });
    }
    return {
        id: id,
        sku: sku,
        image: image,
        media_gallery: media_gallery,
        color: color,
        colorUID: colorUID
    };
};

;// CONCATENATED MODULE: ./hooks/products/useSelectColor.js
function useSelectColor_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSelectColor_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSelectColor_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useSelectColor_arrayLikeToArray(arr);
}
function useSelectColor_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useSelectColor_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useSelectColor_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSelectColor_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSelectColor_slicedToArray(arr, i) {
    return useSelectColor_arrayWithHoles(arr) || useSelectColor_iterableToArrayLimit(arr, i) || useSelectColor_unsupportedIterableToArray(arr, i) || useSelectColor_nonIterableRest();
}
function useSelectColor_toConsumableArray(arr) {
    return useSelectColor_arrayWithoutHoles(arr) || useSelectColor_iterableToArray(arr) || useSelectColor_unsupportedIterableToArray(arr) || useSelectColor_nonIterableSpread();
}
function useSelectColor_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSelectColor_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSelectColor_arrayLikeToArray(o, minLen);
}



function useSelectColor() {
    var ref = (0,react.useState)(null), selectedColor = ref[0], setSelectedColor = ref[1];
    var ref1 = useSelectColor_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productVariantsAtom */.CA), 2), variants = ref1[0], setVariants = ref1[1];
    var setImages = (0,jotai_esm/* useSetAtom */.b9)(store/* productImagesAtom */.cj);
    var setProductID = (0,jotai_esm/* useSetAtom */.b9)(store/* productIdAtom */.CE);
    var selectColor = (0,react.useCallback)(function(id, sku, uid, images) {
        setProductID(id);
        setSelectedColor(sku);
        setVariants(useSelectColor_toConsumableArray(variants).concat([
            {
                sku: sku,
                uid: uid,
                attribute: "v__rv"
            }
        ]));
        setImages(images);
    }, []);
    (0,react.useEffect)(function() {
        if ((variants === null || variants === void 0 ? void 0 : variants.length) === 0) {
            setSelectedColor(null);
        }
    }, [
        variants
    ]);
    return {
        selectedColor: selectedColor,
        selectColor: selectColor
    };
};

;// CONCATENATED MODULE: ./components/Product/ColorSelect/ColorBox.js
function ColorBox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ColorBox_templateObject() {
    var data = ColorBox_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n\n  span:last-of-type {\n    text-align: center;\n    font-size: xxsmall;\n    color: gray-200;\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n"
    ]);
    ColorBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ColorBox_templateObject1() {
    var data = ColorBox_taggedTemplateLiteral([
        "\n  padding: 0.1rem;\n  border: ",
        ";\n  border-radius: 5px;\n  overflow: hidden;\n"
    ]);
    ColorBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ColorBoxContainer = styled_components_esm/* default.span */.ZPm.span(ColorBox_templateObject());
var ImageBox = styled_components_esm/* default.span */.ZPm.span(ColorBox_templateObject1(), function(param) {
    var selected = param.selected;
    return selected ? "1px solid #6F758B" : "1px solid transparent";
});
function ColorBox(param) {
    var image = param.image, color = param.color, selected = param.selected, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColorBoxContainer, {
        role: "button",
        "aria-label": "Select product colorway",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                selected: selected,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image === null || image === void 0 ? void 0 : image.url,
                    alt: image === null || image === void 0 ? void 0 : image.label,
                    width: 64,
                    height: 64
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: color
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Primitives/CarouselArrow.js
var CarouselArrow = __webpack_require__(7184);
;// CONCATENATED MODULE: ./components/Product/ColorSelect/Slider.js
function ColorSelect_Slider_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ColorSelect_Slider_templateObject() {
    var data = ColorSelect_Slider_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  max-width: 500px;\n  padding-top: 1rem;\n"
    ]);
    ColorSelect_Slider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ColorSelect_Slider_templateObject1() {
    var data = ColorSelect_Slider_taggedTemplateLiteral([
        "\n  position: relative;\n  right: ",
        ";\n  cursor: pointer;\n\n  span svg {\n    transform: scale(0.4);\n  }\n"
    ]);
    ColorSelect_Slider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Slider_templateObject2() {
    var data = ColorSelect_Slider_taggedTemplateLiteral([
        "\n  margin-left: -1.5rem;\n\n  @media (max-width: desktop) {\n    display: none;\n  }\n"
    ]);
    Slider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SliderContainer = styled_components_esm/* default.div */.ZPm.div(ColorSelect_Slider_templateObject());
var Slider_Arrow = styled_components_esm/* default.div */.ZPm.div(ColorSelect_Slider_templateObject1(), function(param) {
    var prev = param.prev, next = param.next;
    return prev ? "2rem" : next && "0.5rem";
});
var Slider_StyledSwiper = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(Slider_templateObject2());
function ColorSlider(param) {
    var variants = param.variants;
    var swiperRef = (0,react.useRef)(null);
    var colors = variants === null || variants === void 0 ? void 0 : variants.length;
    var ref1 = useSelectColor(), selectedColor = ref1.selectedColor, selectColor = ref1.selectColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderContainer, {
        children: [
            colors > 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Arrow, {
                prev: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrow/* default */.Z, {
                    onClick: function() {
                        return swiperRef.current.swiper.slidePrev();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowLeft */.wT, {
                        strokeWidth: 8
                    })
                })
            }),
            colors > 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_StyledSwiper, {
                ref: swiperRef,
                slidesPerView: 5,
                loop: true,
                children: variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
                    var ref = mapProductVariantAttributes(variant), id = ref.id, sku = ref.sku, image = ref.image, media_gallery = ref.media_gallery, color = ref.color, colorUID = ref.colorUID;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBox, {
                            image: image,
                            color: color,
                            selected: selectedColor === sku,
                            onClick: function() {
                                return selectColor(id, sku, colorUID, media_gallery);
                            }
                        })
                    }, sku);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                spaceX: "1rem",
                whiteSpace: "nowrap",
                children: variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
                    var ref = mapProductVariantAttributes(variant), id = ref.id, sku = ref.sku, image = ref.image, media_gallery = ref.media_gallery, color = ref.color, colorUID = ref.colorUID;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBox, {
                        image: image,
                        color: color,
                        selected: selectedColor === sku,
                        onClick: function() {
                            return selectColor(id, sku, colorUID, media_gallery);
                        }
                    }, sku);
                })
            }),
            colors > 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Arrow, {
                next: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrow/* default */.Z, {
                    onClick: function() {
                        return swiperRef.current.swiper.slideNext();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowRight */.C$, {
                        strokeWidth: 8
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Product/ColorSelect/Swiper.js
function ColorSelect_Swiper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ColorSelect_Swiper_templateObject() {
    var data = ColorSelect_Swiper_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: max-content;\n  margin: 0.5rem auto 0;\n\n  @media (min-width: desktop) {\n    display: none;\n  }\n"
    ]);
    ColorSelect_Swiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ColorSelect_Swiper_templateObject1() {
    var data = ColorSelect_Swiper_taggedTemplateLiteral([
        "\n  max-width: 620px;\n\n  .swiper-slide {\n    display: block;\n    width: auto;\n  }\n"
    ]);
    ColorSelect_Swiper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Swiper_SwiperContainer = styled_components_esm/* default.div */.ZPm.div(ColorSelect_Swiper_templateObject());
var Swiper_StyledSwiper = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(ColorSelect_Swiper_templateObject1());
function ColorSwiper(param) {
    var variants = param.variants;
    var ref1 = useSelectColor(), selectedColor = ref1.selectedColor, selectColor = ref1.selectColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Swiper_SwiperContainer, {
        children: variants.length > 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Swiper_StyledSwiper, {
            slidesPerView: "auto",
            loop: true,
            children: variants.map(function(variant) {
                var ref = mapProductVariantAttributes(variant), id = ref.id, sku = ref.sku, image = ref.image, media_gallery = ref.media_gallery, color = ref.color, colorUID = ref.colorUID;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBox, {
                        image: image,
                        color: color,
                        selected: selectedColor === sku,
                        onClick: function() {
                            return selectColor(id, sku, colorUID, media_gallery);
                        }
                    })
                }, sku);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
            justify: "center",
            spaceX: "1rem",
            children: variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
                var ref = mapProductVariantAttributes(variant), id = ref.id, sku = ref.sku, image = ref.image, media_gallery = ref.media_gallery, color = ref.color, colorUID = ref.colorUID;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBox, {
                    image: image,
                    color: color,
                    selected: selectedColor === sku,
                    onClick: function() {
                        return selectColor(id, sku, colorUID, media_gallery);
                    }
                }, sku);
            })
        })
    });
};

// EXTERNAL MODULE: ./global/constants.js
var constants = __webpack_require__(827);
;// CONCATENATED MODULE: ./components/Product/Main/StockStatus.js
function StockStatus_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function StockStatus_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function StockStatus_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function StockStatus_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function StockStatus_slicedToArray(arr, i) {
    return StockStatus_arrayWithHoles(arr) || StockStatus_iterableToArrayLimit(arr, i) || StockStatus_unsupportedIterableToArray(arr, i) || StockStatus_nonIterableRest();
}
function StockStatus_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return StockStatus_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return StockStatus_arrayLikeToArray(o, minLen);
}










function StockStatus(param1) {
    var id1 = param1.id, sku = param1.sku, stockStatus = param1.stockStatus, setStockStatus = param1.setStockStatus, product = param1.product;
    var ref5;
    var ref1 = StockStatus_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productIdAtom */.CE), 2), productID = ref1[0], setProductID = ref1[1];
    var ref2 = StockStatus_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productVariantsAtom */.CA), 1), selectedVariants = ref2[0];
    var t = (0,esm/* useTranslation */.$G)().t;
    // Set the product ID
    (0,react.useEffect)(function() {
        return setProductID(id1);
    }, [
        id1
    ]);
    // Helper function to get current variant info
    var getCurrentVariant = function() {
        if (!(selectedVariants === null || selectedVariants === void 0 ? void 0 : selectedVariants.length) || !(product === null || product === void 0 ? void 0 : product.variants)) {
            return {
                sku: sku,
                isVariant: false
            };
        }
        var configurableOptions = product === null || product === void 0 ? void 0 : product.configurable_options;
        var variant;
        if ((configurableOptions === null || configurableOptions === void 0 ? void 0 : configurableOptions.length) > 1 && selectedVariants.length > 1) {
            // Multiple configurable options - find exact match
            var filterValue = selectedVariants.map(function(obj) {
                return obj.uid;
            });
            var options = Array.from(product.variants);
            var possibleOptions = options.filter(function(obj) {
                return filterValue.every(function(uuid) {
                    return obj.attributes.some(function(valueObj) {
                        return valueObj.uid === uuid;
                    });
                });
            });
            if (possibleOptions.length > 0) {
                var ref;
                variant = (ref = possibleOptions[0]) === null || ref === void 0 ? void 0 : ref.product;
            }
        } else if (selectedVariants.length > 0) {
            var ref3;
            // Single configurable option or partial selection
            variant = (ref3 = product.variants.find(function(param) {
                var variantProduct = param.product;
                var ref;
                return (variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.sku) === ((ref = selectedVariants[0]) === null || ref === void 0 ? void 0 : ref.sku);
            })) === null || ref3 === void 0 ? void 0 : ref3.product;
            if (!variant) {
                var ref4;
                variant = (ref4 = product.variants.find(function(param) {
                    var attributes = param.attributes;
                    return attributes === null || attributes === void 0 ? void 0 : attributes.find(function(item) {
                        var ref;
                        return (item === null || item === void 0 ? void 0 : item.uid) === ((ref = selectedVariants[0]) === null || ref === void 0 ? void 0 : ref.uid);
                    });
                })) === null || ref4 === void 0 ? void 0 : ref4.product;
            }
        }
        return {
            sku: (variant === null || variant === void 0 ? void 0 : variant.sku) || sku,
            isVariant: !!variant,
            variantId: variant === null || variant === void 0 ? void 0 : variant.id
        };
    };
    // Get stock statuses of warehouses
    (0,react.useEffect)(function() {
        if (!productID) return;
        var currentVariant = getCurrentVariant();
        var targetProductId = currentVariant.isVariant ? currentVariant.variantId : productID;
        axios_default().post("".concat(constants/* MAGENTO_URI */.mN, "/warehouse.php"), {
            product_id: targetProductId,
            sku: currentVariant.sku
        }).then(function(res) {
            var _data = res.data, success = _data.success, result = _data.result;
            var kvartalStock = 0;
            var warehouseStock = 0;
            if (success && result) {
                var ref, ref6;
                kvartalStock = Number(((ref = result === null || result === void 0 ? void 0 : result.find(function(param) {
                    var id = param.warehouse_id;
                    return id === "2";
                })) === null || ref === void 0 ? void 0 : ref.qty) || 0);
                warehouseStock = Number(((ref6 = result === null || result === void 0 ? void 0 : result.find(function(param) {
                    var id = param.warehouse_id;
                    return id === "1";
                })) === null || ref6 === void 0 ? void 0 : ref6.qty) || 0);
            }
            setStockStatus({
                kvartal: {
                    qty: kvartalStock
                },
                warehouse: {
                    qty: warehouseStock
                }
            });
        }).catch(function(error) {
            (0,minimal_esm/* captureException */.Tb)(error);
        });
    }, [
        productID,
        selectedVariants,
        product === null || product === void 0 ? void 0 : product.variants,
        sku
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
        spaceX: 24,
        children: (stockStatus === null || stockStatus === void 0 ? void 0 : (ref5 = stockStatus.warehouse) === null || ref5 === void 0 ? void 0 : ref5.qty) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Warehouse, {
            name: t("stock")
        })
    });
};
var Warehouse = function(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
        as: "p",
        align: "center",
        mt: -16,
        color: "#52C1D3",
        children: [
            name,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                as: "span",
                w: 12,
                h: 12,
                ml: 6,
                bg: "#96E799",
                borderRadius: "50%"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 3 modules
var react_select_esm = __webpack_require__(5230);
;// CONCATENATED MODULE: ./components/UI/Form/Selects/VariantSelect.js
function VariantSelect_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function VariantSelect_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function VariantSelect_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return VariantSelect_arrayLikeToArray(arr);
}
function VariantSelect_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VariantSelect_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function VariantSelect_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function VariantSelect_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function VariantSelect_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function VariantSelect_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VariantSelect_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function VariantSelect_slicedToArray(arr, i) {
    return VariantSelect_arrayWithHoles(arr) || VariantSelect_iterableToArrayLimit(arr, i) || VariantSelect_unsupportedIterableToArray(arr, i) || VariantSelect_nonIterableRest();
}
function VariantSelect_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function VariantSelect_toConsumableArray(arr) {
    return VariantSelect_arrayWithoutHoles(arr) || VariantSelect_iterableToArray(arr) || VariantSelect_unsupportedIterableToArray(arr) || VariantSelect_nonIterableSpread();
}
function VariantSelect_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return VariantSelect_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return VariantSelect_arrayLikeToArray(o, minLen);
}
function VariantSelect_templateObject() {
    var data = VariantSelect_taggedTemplateLiteral([
        "\n  flex: 1;\n  max-width: 310px;\n"
    ]);
    VariantSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledSelect = (0,styled_components_esm/* default */.ZPm)(react_select_esm/* default */.ZP)(VariantSelect_templateObject());
var VariantSelect = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref, _$ref1;
    var t = (0,esm/* useTranslation */.$G)().t;
    var _$ref2 = VariantSelect_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productVariantsAtom */.CA), 2), variants = _$ref2[0], setVariants = _$ref2[1];
    var _$ref3 = VariantSelect_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* addToCartErrorAtom */.z8), 1), error = _$ref3[0];
    var selectedVariant = {
        attribute: "custom",
        uid: (_$ref = props.value) === null || _$ref === void 0 ? void 0 : _$ref.uid,
        name: (_$ref1 = props.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.attribute
    };
    (0,react.useEffect)(function() {
        if (props.value) {
            var variantSelected = variants === null || variants === void 0 ? void 0 : variants.find(function(item) {
                return item.name === props.value.attribute;
            });
            if (variantSelected) {
                var selected = variants === null || variants === void 0 ? void 0 : variants.filter(function(item) {
                    return item !== variantSelected;
                });
                setVariants(VariantSelect_toConsumableArray(selected).concat([
                    selectedVariant
                ]));
            } else {
                setVariants(VariantSelect_toConsumableArray(variants).concat([
                    selectedVariant
                ]));
            }
        } else if (props.value === null) {
            setVariants([]);
        }
    }, [
        props.value
    ]);
    (0,react.useEffect)(function() {
        (variants === null || variants === void 0 ? void 0 : variants.length) === 0 ? props.reset() : props.setGallery();
    }, [
        variants
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
        ref: ref,
        isClearable: true,
        escapeClearsValue: true,
        name: props.name,
        value: props.value || null,
        onChange: props.onChange,
        options: props.options,
        placeholder: t("ui.choose"),
        styles: {
            container: function(base, state) {
                return VariantSelect_objectSpread({}, base, {
                    marginBottom: "2rem",
                    opacity: state.isDisabled ? 0.4 : 1
                });
            },
            control: function(base) {
                var _obj;
                return VariantSelect_objectSpread({}, base, (_obj = {
                    border: "none",
                    boxShadow: "none",
                    borderRadius: "0",
                    borderBottom: "2px solid ".concat(error ? "red" : "#A8A9BA")
                }, VariantSelect_defineProperty(_obj, "border", error ? "2px solid red" : "none"), VariantSelect_defineProperty(_obj, "background", "#fff"), VariantSelect_defineProperty(_obj, "&:hover", {
                    borderBottom: "2px solid #9596AC"
                }), _obj));
            },
            placerholder: function(base) {
                return VariantSelect_objectSpread({}, base, {
                    "&:hover": {
                        color: "#9596AC"
                    }
                });
            },
            indicatorSeparator: function() {
                return {
                    display: "none"
                };
            },
            dropdownIndicator: function(base, state) {
                return VariantSelect_objectSpread({}, base, {
                    position: "relative",
                    left: "0.25rem",
                    color: "#A8A9BA",
                    cursor: "pointer",
                    transform: state.selectProps.menuIsOpen ? "scale(1.3) rotate(180deg)" : "scale(1.3)",
                    transition: "all 0.3s",
                    "&:hover": {
                        color: "#9596AC"
                    }
                });
            },
            option: function(base, state) {
                return VariantSelect_objectSpread({}, base, {
                    background: state.isSelected ? "#D6D7EA" : "white",
                    cursor: "pointer",
                    ":hover": {
                        background: "#D6D7EA"
                    }
                });
            },
            clearIndicator: function(base) {
                return VariantSelect_objectSpread({}, base, {
                    cursor: "pointer",
                    "&:hover": {
                        color: "#9596AC"
                    }
                });
            }
        }
    });
});
VariantSelect.displayName = "VariantSelect";
/* harmony default export */ var Selects_VariantSelect = (VariantSelect);

;// CONCATENATED MODULE: ./components/Product/Main/CustomOptions.js
function CustomOptions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomOptions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomOptions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








function CustomOptions(param1) {
    var product = param1.product;
    var ref4;
    var ref1 = (0,index_esm/* useForm */.cI)(), control = ref1.control, reset = ref1.reset;
    var selectedVariants = (0,jotai_esm/* useAtomValue */.Dv)(store/* productVariantsAtom */.CA);
    var setImages = (0,jotai_esm/* useSetAtom */.b9)(store/* productImagesAtom */.cj);
    var colors = useColors(product).colors;
    var customOptions = product === null || product === void 0 ? void 0 : (ref4 = product.configurable_options) === null || ref4 === void 0 ? void 0 : ref4.filter(function(option) {
        return option.attribute_code !== "v__rv";
    });
    var getConfigurableOptionValues = function(attribute) {
        var ref, ref2, ref3;
        var options = (ref2 = product === null || product === void 0 ? void 0 : (ref = product.configurable_options) === null || ref === void 0 ? void 0 : ref.filter(function(option) {
            return option.attribute_code === attribute;
        })[0]) === null || ref2 === void 0 ? void 0 : ref2.values;
        return (ref3 = options === null || options === void 0 ? void 0 : options.map(function(option) {
            return CustomOptions_objectSpread({}, option, {
                value: option.label,
                attribute: attribute
            });
        })) === null || ref3 === void 0 ? void 0 : ref3.sort(function(a, b) {
            return a.label - b.label;
        });
    };
    var setGallery = (0,react.useCallback)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function(_iterator, _step) {
                var variant = _step.value;
                var ref;
                var color = colors === null || colors === void 0 ? void 0 : colors.find(function(param2) {
                    var attributes = param2.attributes;
                    return attributes.find(function(param) {
                        var uid = param.uid;
                        return uid === variant.uid;
                    });
                });
                var images = color === null || color === void 0 ? void 0 : (ref = color.product) === null || ref === void 0 ? void 0 : ref.media_gallery;
                setImages((images === null || images === void 0 ? void 0 : images.length) > 0 ? images : product === null || product === void 0 ? void 0 : product.media_gallery);
            };
            for(var _iterator = selectedVariants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop(_iterator, _step);
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        selectedVariants,
        colors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
        dir: "column",
        pt: {
            _: 8,
            desktop: 40
        },
        pb: {
            _: (customOptions === null || customOptions === void 0 ? void 0 : customOptions.length) > 0 ? 8 : 0,
            desktop: 16
        },
        children: (customOptions === null || customOptions === void 0 ? void 0 : customOptions.length) > 0 && customOptions.map(function(param3) {
            var attribute_code = param3.attribute_code, label = param3.label;
            var optionValues = getConfigurableOptionValues(attribute_code);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                        children: [
                            label,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        name: label,
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Selects_VariantSelect, CustomOptions_objectSpread({}, field, {
                                options: optionValues,
                                setGallery: setGallery,
                                reset: reset
                            }));
                        }
                    })
                ]
            }, label);
        })
    });
};

// EXTERNAL MODULE: ./hooks/account/useWishlist.js + 1 modules
var useWishlist = __webpack_require__(3163);
// EXTERNAL MODULE: ./hooks/account/useWishlistData.js
var useWishlistData = __webpack_require__(7532);
// EXTERNAL MODULE: ./components/UI/Button/index.js
var Button = __webpack_require__(8356);
;// CONCATENATED MODULE: ./components/Product/Main/Favorite.js
function Favorite_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Favorite_templateObject() {
    var data = Favorite_taggedTemplateLiteral([
        "\n  display: inline-flex;\n\n  &:hover {\n    svg g {\n      fill: ",
        ";\n    }\n  } \n"
    ]);
    Favorite_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var WishlistButton = (0,styled_components_esm/* default */.ZPm)(Button/* default */.Z)(Favorite_templateObject(), function(param) {
    var favorited = param.favorited;
    return favorited ? "none" : system_esm.th.color("pink-100");
});
function Favorite(param) {
    var product = param.product;
    var t = (0,esm/* useTranslation */.$G)().t;
    var itemId = (0,useWishlistData/* default */.Z)(product).itemId;
    var ref = (0,useWishlist/* default */.Z)(product), addToWishlist = ref.addToWishlist, removeFromWishlist = ref.removeFromWishlist;
    var handleFavorite = function() {
        itemId ? removeFromWishlist() : addToWishlist();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WishlistButton, {
        spaceX: 8,
        onClick: handleFavorite,
        favorited: itemId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "img",
                "aria-label": "Heart icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Heart */.Xd, {
                    fill: itemId ? "#fe93bf" : "none"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                as: "span",
                fontSize: "0.875rem",
                color: "gray-200",
                children: itemId ? t("wishlist.remove") : t("wishlist.add")
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Button/Variants/Primary.js
var Primary = __webpack_require__(6803);
// EXTERNAL MODULE: ./components/UI/Primitives/Headings.js
var Headings = __webpack_require__(7133);
// EXTERNAL MODULE: ./components/UI/Ratings/StarRating.js
var StarRating = __webpack_require__(9565);
// EXTERNAL MODULE: ./components/UI/Loader/Spinner.js
var Spinner = __webpack_require__(7162);
// EXTERNAL MODULE: ./components/UI/Icons/SingleProduct/index.js
var SingleProduct = __webpack_require__(3814);
;// CONCATENATED MODULE: ./components/Product/Main/styles.js
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  margin: 4rem 0;\n\n  @media (max-width: desktop) {\n    display: flex;\n    flex-direction: column;\n    margin: 0;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n      h4 {\n        color: red;\n        text-decoration: underline;\n      }\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: 6rem;\n\n  p,\n  h4 {\n    font-weight: 400;\n  }\n\n  h4 {\n    padding-bottom: 1rem;\n  }\n\n  p {\n    max-width: 400px;\n    padding-bottom: 2rem;\n  }\n\n  a {\n    font-size: 0.875rem;\n    text-decoration: underline;\n  }\n\n  a.brand_logo {\n    position: absolute;\n    width: 100px;\n    height: 100px;\n    top: 20px;\n    right: 0;\n  }\n\n  @media (max-width: desktop) {\n    margin-left: 0;\n    padding: 0 1rem;\n\n    a.brand_logo {\n      display: none;\n    }\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-bottom: 2rem;\n  font-size: large;\n  font-weight: 500;\n  color: teal-200;\n\n  div {\n    font-weight: 500;\n    font-size: medium;\n  }\n\n  > span {\n    margin-left: 2rem;\n    font-size: xsmall;\n    color: blue-200;\n\n    span {\n      position: relative;\n      font-size: small;\n\n      &:after {\n        ",
        "\n      }\n    }\n  }\n\n  @media (max-width: desktop) {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n\n    > span {\n      margin-left: 0;\n\n      span {\n        margin-left: 0.5rem;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ProductDetails = styled_components_esm/* default.section */.ZPm.section(styles_templateObject());
var ProductInformation = styled_components_esm/* default.div */.ZPm.div(styles_templateObject2(), function(param) {
    var error = param.error;
    return error && (0,styled_components_esm/* css */.ivY)(styles_templateObject1());
});
var PriceInformation = styled_components_esm/* default.span */.ZPm.span(styles_templateObject3(), utils/* CrossOut */.B4);

;// CONCATENATED MODULE: ./data/brands.json
var brands_namespaceObject = JSON.parse('[{"__typename":"MageplazaBrands","value":"ABC Design","image":"https://do.baltbaby.com/media/mageplaza/brand/ABCDesign_Logo2.jpg","url_key":"abc-design","option_id":3993,"is_featured":0},{"__typename":"MageplazaBrands","value":"AeroMoov","image":"https://do.baltbaby.com/media/mageplaza/brand/Aeromoov-Logo.jpg","url_key":"aeromoov","option_id":4213,"is_featured":0},{"__typename":"MageplazaBrands","value":"AeroSleep","image":"https://do.baltbaby.com/media/mageplaza/brand/aerosleep_logo3.jpg","url_key":"aerosleep","option_id":4118,"is_featured":0},{"__typename":"MageplazaBrands","value":"Akros","image":"https://do.baltbaby.com/media/mageplaza/brand/akros.png","url_key":"akros","option_id":784,"is_featured":0},{"__typename":"MageplazaBrands","value":"Alecto","image":"https://do.baltbaby.com/media/mageplaza/brand/0x0.png","url_key":"alecto","option_id":3717,"is_featured":0},{"__typename":"MageplazaBrands","value":"ALPHANOVA","image":"https://do.baltbaby.com/media/mageplaza/brand/alphanova.png","url_key":"alphanova-r","option_id":3460,"is_featured":0},{"__typename":"MageplazaBrands","value":"Alpine","image":"https://do.baltbaby.com/media/mageplaza/brand/alpine-hearing-protection.png","url_key":"alpine","option_id":3523,"is_featured":0},{"__typename":"MageplazaBrands","value":"Ankras","image":"https://do.baltbaby.com/media/mageplaza/brand/logo-ankras-160-en.jpg","url_key":"ankras","option_id":2710,"is_featured":0},{"__typename":"MageplazaBrands","value":"AquaScale","image":"https://do.baltbaby.com/media/mageplaza/brand/Aquasqale_logo_baltbaby.jpg","url_key":"aquascale","option_id":3253,"is_featured":0},{"__typename":"MageplazaBrands","value":"Avionaut","image":"https://do.baltbaby.com/media/mageplaza/brand/Avionaut-Logo.jpg","url_key":"avionaut","option_id":3986,"is_featured":0},{"__typename":"MageplazaBrands","value":"AXKID","image":"https://do.baltbaby.com/media/mageplaza/brand/axkid_1.png","url_key":"axkid","option_id":775,"is_featured":0},{"__typename":"MageplazaBrands","value":"Baby Einstein","image":"https://do.baltbaby.com/media/mageplaza/brand/Baby-Einstein-logo.jpg","url_key":"baby-einstein","option_id":3967,"is_featured":0},{"__typename":"MageplazaBrands","value":"Baby Jogger","image":"https://do.baltbaby.com/media/mageplaza/brand/babyjogger_2.jpg","url_key":"baby-jogger","option_id":741,"is_featured":0},{"__typename":"MageplazaBrands","value":"Baby Wallaby","image":"https://do.baltbaby.com/media/mageplaza/brand/babywallaby.jpg","url_key":"baby-wallaby","option_id":720,"is_featured":0},{"__typename":"MageplazaBrands","value":"Babybjörn","image":"https://do.baltbaby.com/media/mageplaza/brand/babybjorn_1.jpg","url_key":"babybjorn","option_id":742,"is_featured":0},{"__typename":"MageplazaBrands","value":"BabyDan","image":"https://do.baltbaby.com/media/mageplaza/brand/Babydan.png","url_key":"babydan","option_id":3384,"is_featured":0},{"__typename":"MageplazaBrands","value":"Babymoov","image":"https://do.baltbaby.com/media/mageplaza/brand/babymoov-logo-vector.png","url_key":"babymoov","option_id":3626,"is_featured":0},{"__typename":"MageplazaBrands","value":"BabyOno","image":"https://do.baltbaby.com/media/mageplaza/brand/babyono.png","url_key":"babyono","option_id":732,"is_featured":0},{"__typename":"MageplazaBrands","value":"Béaba","image":"https://do.baltbaby.com/media/mageplaza/brand/beaba-logo.jpg","url_key":"beaba","option_id":4117,"is_featured":0},{"__typename":"MageplazaBrands","value":"Bebeconfort","image":"https://do.baltbaby.com/media/mageplaza/brand/bebeconfort_logo.jpg","url_key":"bebeconfort","option_id":3880,"is_featured":0},{"__typename":"MageplazaBrands","value":"Beleduc","image":"https://do.baltbaby.com/media/mageplaza/brand/beleduc.jpg","url_key":"beleduc","option_id":786,"is_featured":0},{"__typename":"MageplazaBrands","value":"BeSafe","image":"https://do.baltbaby.com/media/mageplaza/brand/logo-2.png","url_key":"besafe","option_id":4014,"is_featured":0},{"__typename":"MageplazaBrands","value":"Bestway","image":"https://do.baltbaby.com/media/mageplaza/brand/bestway-logo-1.png","url_key":"bestway","option_id":3786,"is_featured":0},{"__typename":"MageplazaBrands","value":"Bibs","image":"https://do.baltbaby.com/media/mageplaza/brand/bibs_logo_baltbaby.png","url_key":"bibs","option_id":2609,"is_featured":0},{"__typename":"MageplazaBrands","value":"Bocioland","image":"https://do.baltbaby.com/media/mageplaza/brand/BOCIOLAND.jpg","url_key":"bocioland","option_id":3909,"is_featured":0},{"__typename":"MageplazaBrands","value":"Bozz","image":"https://do.baltbaby.com/media/mageplaza/brand/logo.jpg","url_key":"bozz","option_id":3692,"is_featured":0},{"__typename":"MageplazaBrands","value":"Britton","image":"https://do.baltbaby.com/media/mageplaza/brand/images-3.png","url_key":"britton","option_id":3630,"is_featured":0},{"__typename":"MageplazaBrands","value":"Brush Baby","image":"https://do.baltbaby.com/media/mageplaza/brand/brushbaby.jpg","url_key":"brush-baby","option_id":879,"is_featured":0},{"__typename":"MageplazaBrands","value":"Buddy & Hope","image":"https://do.baltbaby.com/media/mageplaza/brand/BuddyHope.png","url_key":"buddy-hope","option_id":749,"is_featured":0},{"__typename":"MageplazaBrands","value":"Bumbleride","image":"https://do.baltbaby.com/media/mageplaza/brand/bumbleride_logo_baltbaby.png","url_key":"bumbleride","option_id":2681,"is_featured":0},{"__typename":"MageplazaBrands","value":"Buubla","image":"https://do.baltbaby.com/media/mageplaza/brand/buubla.jpg","url_key":"buubla","option_id":813,"is_featured":0},{"__typename":"MageplazaBrands","value":"Canpol Babies","image":"https://do.baltbaby.com/media/mageplaza/brand/canpolbabies.png","url_key":"canpol-babies","option_id":713,"is_featured":0},{"__typename":"MageplazaBrands","value":"CAPiDi","image":"https://do.baltbaby.com/media/mageplaza/brand/images-5.png","url_key":"capidi","option_id":3714,"is_featured":0},{"__typename":"MageplazaBrands","value":"Caretero","image":"https://do.baltbaby.com/media/mageplaza/brand/348341226_642544621176283_1802086354728595652_n.jpg","url_key":"caretero","option_id":3892,"is_featured":0},{"__typename":"MageplazaBrands","value":"Cariboo","image":"https://do.baltbaby.com/media/mageplaza/brand/262-home_default.jpeg","url_key":"cariboo","option_id":3431,"is_featured":0},{"__typename":"MageplazaBrands","value":"Ceba Baby","image":"https://do.baltbaby.com/media/mageplaza/brand/ceba_baby_logo.jpg","url_key":"ceba-baby","option_id":3926,"is_featured":0},{"__typename":"MageplazaBrands","value":"Childhome","image":"https://do.baltbaby.com/media/mageplaza/brand/childhome_1.jpg","url_key":"childhome","option_id":716,"is_featured":0},{"__typename":"MageplazaBrands","value":"Colorino Kids","image":"https://do.baltbaby.com/media/mageplaza/brand/colorino_logo.jpg","url_key":"colorino-kids","option_id":4040,"is_featured":0},{"__typename":"MageplazaBrands","value":"Connetix","image":"https://do.baltbaby.com/media/mageplaza/brand/Connetix-Main-Logo_1.png","url_key":"connetix","option_id":3650,"is_featured":0},{"__typename":"MageplazaBrands","value":"Crayon Rocks","image":"https://do.baltbaby.com/media/mageplaza/brand/Crayon_rocks_Logo.jpg","url_key":"crayon-rocks","option_id":3984,"is_featured":0},{"__typename":"MageplazaBrands","value":"Danpol","image":"https://do.baltbaby.com/media/mageplaza/brand/danpol_1.jpg","url_key":"danpol","option_id":738,"is_featured":0},{"__typename":"MageplazaBrands","value":"Dave & Jon\'s","image":"https://do.baltbaby.com/media/mageplaza/brand/Dave_and_Jons_logo.png","url_key":"dave-jon-s","option_id":4443,"is_featured":0},{"__typename":"MageplazaBrands","value":"Dino","image":"https://do.baltbaby.com/media/mageplaza/brand/Dino_logo.png","url_key":"dino","option_id":3506,"is_featured":0},{"__typename":"MageplazaBrands","value":"Diono","image":"https://do.baltbaby.com/media/mageplaza/brand/Diono_logo-01_highres.png","url_key":"diono","option_id":3409,"is_featured":0},{"__typename":"MageplazaBrands","value":"Djeco","image":"https://do.baltbaby.com/media/mageplaza/brand/djeco.png","url_key":"djeco","option_id":787,"is_featured":0},{"__typename":"MageplazaBrands","value":"Doona","image":"https://do.baltbaby.com/media/mageplaza/brand/doona_logo_baltbaby.png","url_key":"doona","option_id":2692,"is_featured":0},{"__typename":"MageplazaBrands","value":"Easywalker","image":"https://do.baltbaby.com/media/mageplaza/brand/Easywalker_logo_baltbaby.png","url_key":"easywalker","option_id":708,"is_featured":1},{"__typename":"MageplazaBrands","value":"Educo","image":"https://do.baltbaby.com/media/mageplaza/brand/Educo.png","url_key":"educo","option_id":3435,"is_featured":0},{"__typename":"MageplazaBrands","value":"Effiki","image":"https://do.baltbaby.com/media/mageplaza/brand/effiki.jpg","url_key":"effiki","option_id":814,"is_featured":0},{"__typename":"MageplazaBrands","value":"Egg","image":"https://do.baltbaby.com/media/mageplaza/brand/egg.jpeg","url_key":"egg","option_id":811,"is_featured":0},{"__typename":"MageplazaBrands","value":"Emmaljunga","image":"https://do.baltbaby.com/media/mageplaza/brand/Emma_logo_blue.jpg","url_key":"emmaljunga","option_id":4022,"is_featured":0},{"__typename":"MageplazaBrands","value":"EverEarth","image":"https://do.baltbaby.com/media/mageplaza/brand/EverEarth_greentoday-heretomorrow.png","url_key":"everearth","option_id":3436,"is_featured":0},{"__typename":"MageplazaBrands","value":"Fehn","image":"https://do.baltbaby.com/media/mageplaza/brand/fehn.png","url_key":"fehn","option_id":737,"is_featured":0},{"__typename":"MageplazaBrands","value":"Friendly Organic","image":"https://do.baltbaby.com/media/mageplaza/brand/Logo-Friendly-organic.png","url_key":"friendly-organic","option_id":3503,"is_featured":0},{"__typename":"MageplazaBrands","value":"Fruitfunk","image":"https://do.baltbaby.com/media/mageplaza/brand/fruit_funk_logo.jpg","url_key":"fruitfunk","option_id":4223,"is_featured":0},{"__typename":"MageplazaBrands","value":"Globber","image":"https://do.baltbaby.com/media/mageplaza/brand/globberpng.jpg","url_key":"globber","option_id":759,"is_featured":0},{"__typename":"MageplazaBrands","value":"GoBabyGo","image":"https://do.baltbaby.com/media/mageplaza/brand/gobabygo-logo.jpg","url_key":"gobabygo","option_id":4004,"is_featured":0},{"__typename":"MageplazaBrands","value":"Gonge","image":"https://do.baltbaby.com/media/mageplaza/brand/gonge.png","url_key":"gonge","option_id":782,"is_featured":0},{"__typename":"MageplazaBrands","value":"Good Bubble","image":"https://do.baltbaby.com/media/mageplaza/brand/goodbubble.png","url_key":"good-bubble","option_id":726,"is_featured":0},{"__typename":"MageplazaBrands","value":"Greentom","image":"https://do.baltbaby.com/media/mageplaza/brand/Greentom_logo.jpg","url_key":"greentom","option_id":3813,"is_featured":0},{"__typename":"MageplazaBrands","value":"Haba","image":"https://do.baltbaby.com/media/mageplaza/brand/HABA_Logo.png","url_key":"haba","option_id":3705,"is_featured":0},{"__typename":"MageplazaBrands","value":"Hape","image":"https://do.baltbaby.com/media/mageplaza/brand/hape_1.png","url_key":"hape","option_id":950,"is_featured":0},{"__typename":"MageplazaBrands","value":"Hauck","image":"https://do.baltbaby.com/media/mageplaza/brand/hauck_1.png","url_key":"hauck","option_id":712,"is_featured":0},{"__typename":"MageplazaBrands","value":"Helkima","image":"https://do.baltbaby.com/media/mageplaza/brand/Original-logo.png","url_key":"helkima","option_id":3766,"is_featured":0},{"__typename":"MageplazaBrands","value":"Heutink","image":"https://do.baltbaby.com/media/mageplaza/brand/heutink.jpg","url_key":"heutink","option_id":783,"is_featured":0},{"__typename":"MageplazaBrands","value":"Huggies","image":"https://do.baltbaby.com/media/mageplaza/brand/huggies_1.jpg","url_key":"huggies","option_id":723,"is_featured":0},{"__typename":"MageplazaBrands","value":"InnoGio","image":"https://do.baltbaby.com/media/mageplaza/brand/innoGIO_logo.jpg","url_key":"innogio","option_id":3884,"is_featured":0},{"__typename":"MageplazaBrands","value":"IPS srl","image":"https://do.baltbaby.com/media/mageplaza/brand/ips_srl.png","url_key":"ips-srl","option_id":3508,"is_featured":0},{"__typename":"MageplazaBrands","value":"Joha","image":"https://do.baltbaby.com/media/mageplaza/brand/JOHA-logo.png","url_key":"joha","option_id":3935,"is_featured":0},{"__typename":"MageplazaBrands","value":"Just for tots","image":"https://do.baltbaby.com/media/mageplaza/brand/justfortots_logo.jpg","url_key":"just-for-tots","option_id":4003,"is_featured":0},{"__typename":"MageplazaBrands","value":"Kaiser","image":"https://do.baltbaby.com/media/mageplaza/brand/kaiser.png","url_key":"kaiser","option_id":812,"is_featured":0},{"__typename":"MageplazaBrands","value":"Keeeper","image":"https://do.baltbaby.com/media/mageplaza/brand/keeeper_1.jpg","url_key":"keeeper","option_id":832,"is_featured":0},{"__typename":"MageplazaBrands","value":"Kietla","image":"https://do.baltbaby.com/media/mageplaza/brand/KiETLA_logo_black_240x240.png","url_key":"kietla","option_id":3410,"is_featured":0},{"__typename":"MageplazaBrands","value":"KipKep","image":"https://do.baltbaby.com/media/mageplaza/brand/logo_KipKep_baltbaby.jpg","url_key":"kipkep","option_id":2720,"is_featured":0},{"__typename":"MageplazaBrands","value":"Kobi","image":"https://do.baltbaby.com/media/mageplaza/brand/kobi_1.png","url_key":"kobi","option_id":823,"is_featured":0},{"__typename":"MageplazaBrands","value":"Kokadi","image":"https://do.baltbaby.com/media/mageplaza/brand/kokadi_1.jpg","url_key":"kokadi","option_id":825,"is_featured":0},{"__typename":"MageplazaBrands","value":"Kriss","image":"https://do.baltbaby.com/media/mageplaza/brand/kris.jpg","url_key":"kriss","option_id":3774,"is_featured":0},{"__typename":"MageplazaBrands","value":"Lansinoh","image":"https://do.baltbaby.com/media/mageplaza/brand/lansinoh.png","url_key":"lansinoh","option_id":739,"is_featured":0},{"__typename":"MageplazaBrands","value":"Le Toy Van","image":"https://do.baltbaby.com/media/mageplaza/brand/Le_Toy_Van_logo_baltbaby2.png","url_key":"le-toy-van","option_id":2620,"is_featured":0},{"__typename":"MageplazaBrands","value":"Leclerc","image":"https://do.baltbaby.com/media/mageplaza/brand/leclerc_1.jpg","url_key":"leclerc","option_id":896,"is_featured":0},{"__typename":"MageplazaBrands","value":"LEGO®","image":"https://do.baltbaby.com/media/mageplaza/brand/lego.png","url_key":"legor","option_id":722,"is_featured":1},{"__typename":"MageplazaBrands","value":"Leokid","image":"https://do.baltbaby.com/media/mageplaza/brand/leokid.jpg","url_key":"leokid","option_id":707,"is_featured":0},{"__typename":"MageplazaBrands","value":"Limas","image":"https://do.baltbaby.com/media/mageplaza/brand/limas_1.png","url_key":"limas","option_id":827,"is_featured":0},{"__typename":"MageplazaBrands","value":"Linea MammaBaby","image":"https://do.baltbaby.com/media/mageplaza/brand/linea_1.jpg","url_key":"linea-mammababy","option_id":761,"is_featured":0},{"__typename":"MageplazaBrands","value":"Lovi","image":"https://do.baltbaby.com/media/mageplaza/brand/lovi_logo.jpg","url_key":"lovi","option_id":3983,"is_featured":0},{"__typename":"MageplazaBrands","value":"Lucy&Leo","image":"https://do.baltbaby.com/media/mageplaza/brand/lucyleo.jpg","url_key":"lucy-leo","option_id":735,"is_featured":0},{"__typename":"MageplazaBrands","value":"Luula","image":"https://do.baltbaby.com/media/mageplaza/brand/logo-grey-2.png","url_key":"luula","option_id":3604,"is_featured":0},{"__typename":"MageplazaBrands","value":"Makaszka","image":"https://do.baltbaby.com/media/mageplaza/brand/makaszka_logo.jpg","url_key":"makaszka","option_id":717,"is_featured":0},{"__typename":"MageplazaBrands","value":"Maltex","image":"https://do.baltbaby.com/media/mageplaza/brand/logo-3.png","url_key":"maltex","option_id":4041,"is_featured":0},{"__typename":"MageplazaBrands","value":"Marcus & Marcus","image":"https://do.baltbaby.com/media/mageplaza/brand/marcusandmarcus_logo_baltbaby.png","url_key":"marcus-marcus","option_id":3298,"is_featured":0},{"__typename":"MageplazaBrands","value":"Matchstick Monkey","image":"https://do.baltbaby.com/media/mageplaza/brand/matchstick_monkey.jpg","url_key":"matchstick-monkey","option_id":757,"is_featured":0},{"__typename":"MageplazaBrands","value":"Maxi-Cosi","image":"https://do.baltbaby.com/media/mageplaza/brand/Maxi-Cosi_logo_baltbaby.png","url_key":"maxi-cosi","option_id":709,"is_featured":1},{"__typename":"MageplazaBrands","value":"MEMBANTU","image":"https://do.baltbaby.com/media/mageplaza/brand/membantu_logo_1.jpg","url_key":"membantu","option_id":4224,"is_featured":0},{"__typename":"MageplazaBrands","value":"Micro","image":"https://do.baltbaby.com/media/mageplaza/brand/micro-scooters-ltd-logo-vector.png","url_key":"micro","option_id":3826,"is_featured":0},{"__typename":"MageplazaBrands","value":"Milda Playdough","image":"https://do.baltbaby.com/media/mageplaza/brand/milda.jpg","url_key":"milda-playdough","option_id":752,"is_featured":0},{"__typename":"MageplazaBrands","value":"Miniland","image":"https://do.baltbaby.com/media/mageplaza/brand/miniland.jpg","url_key":"miniland","option_id":746,"is_featured":0},{"__typename":"MageplazaBrands","value":"MiniMeis","image":"https://do.baltbaby.com/media/mageplaza/brand/minimeis.png","url_key":"minimeis","option_id":3492,"is_featured":0},{"__typename":"MageplazaBrands","value":"Minimonkey","image":"https://do.baltbaby.com/media/mageplaza/brand/Minimonkley.png","url_key":"minimonkey","option_id":2571,"is_featured":0},{"__typename":"MageplazaBrands","value":"Mininor","image":"https://do.baltbaby.com/media/mageplaza/brand/mininor_RGB_black_500px-1.png","url_key":"mininor","option_id":3633,"is_featured":0},{"__typename":"MageplazaBrands","value":"Mömbella","image":"https://do.baltbaby.com/media/mageplaza/brand/Mombella_Logo.jpg","url_key":"mombella","option_id":3968,"is_featured":0},{"__typename":"MageplazaBrands","value":"Moonie","image":"https://do.baltbaby.com/media/mageplaza/brand/logo.png","url_key":"moonie","option_id":2597,"is_featured":0},{"__typename":"MageplazaBrands","value":"Movino","image":"https://do.baltbaby.com/media/mageplaza/brand/logo-black_movino.png","url_key":"movino","option_id":3426,"is_featured":0},{"__typename":"MageplazaBrands","value":"Muksutalli","image":"https://do.baltbaby.com/media/mageplaza/brand/muksutalli.jpg","url_key":"muksutalli","option_id":3886,"is_featured":0},{"__typename":"MageplazaBrands","value":"Muuvo","image":"https://do.baltbaby.com/media/mageplaza/brand/muuvo-logo.png","url_key":"muuvo","option_id":3734,"is_featured":0},{"__typename":"MageplazaBrands","value":"My first JUMPY","image":"https://do.baltbaby.com/media/mageplaza/brand/Jumpy_huppeloomad.jpg","url_key":"my-first-jumpy","option_id":4043,"is_featured":0},{"__typename":"MageplazaBrands","value":"My Memi","image":"https://do.baltbaby.com/media/mageplaza/brand/logo_mymemi.png","url_key":"my-memi","option_id":3452,"is_featured":0},{"__typename":"MageplazaBrands","value":"Naïf ","image":"https://do.baltbaby.com/media/mageplaza/brand/naif_1.jpg","url_key":"naif","option_id":721,"is_featured":0},{"__typename":"MageplazaBrands","value":"Neno","image":"https://do.baltbaby.com/media/mageplaza/brand/neno-logo.jpg","url_key":"neno","option_id":3885,"is_featured":0},{"__typename":"MageplazaBrands","value":"Nõgel","image":"https://do.baltbaby.com/media/mageplaza/brand/nogel.png","url_key":"nogel","option_id":724,"is_featured":0},{"__typename":"MageplazaBrands","value":"Nordic Crown","image":"https://do.baltbaby.com/media/mageplaza/brand/nordic_crown.jpg","url_key":"nordic-crown","option_id":714,"is_featured":0},{"__typename":"MageplazaBrands","value":"Nuuroo","image":"https://do.baltbaby.com/media/mageplaza/brand/logo_nuuroo.png","url_key":"nuuroo","option_id":3621,"is_featured":0},{"__typename":"MageplazaBrands","value":"Oli&Carol","image":"https://do.baltbaby.com/media/mageplaza/brand/oli-and-carol-logo-square.jpg","url_key":"oli-carol","option_id":3292,"is_featured":0},{"__typename":"MageplazaBrands","value":"Oma Care","image":"https://do.baltbaby.com/media/mageplaza/brand/oma-logo-black.png","url_key":"oma-care","option_id":3571,"is_featured":0},{"__typename":"MageplazaBrands","value":"Pampers","image":"https://do.baltbaby.com/media/mageplaza/brand/pampers_logo_baltbaby.png","url_key":"pampers","option_id":3293,"is_featured":0},{"__typename":"MageplazaBrands","value":"Petit&Jolie","image":"https://do.baltbaby.com/media/mageplaza/brand/petit_jolie.png","url_key":"petit-jolie","option_id":740,"is_featured":0},{"__typename":"MageplazaBrands","value":"PLASTKON","image":"https://do.baltbaby.com/media/mageplaza/brand/plastkon_logo_baltbaby.jpg","url_key":"plastkon","option_id":3973,"is_featured":0},{"__typename":"MageplazaBrands","value":"Playgro","image":"https://do.baltbaby.com/media/mageplaza/brand/playgro_1.jpg","url_key":"playgro","option_id":755,"is_featured":0},{"__typename":"MageplazaBrands","value":"Pure Beginnings","image":"https://do.baltbaby.com/media/mageplaza/brand/pure-beginnings.png","url_key":"pure-beginnings","option_id":747,"is_featured":0},{"__typename":"MageplazaBrands","value":"Quut","image":"https://do.baltbaby.com/media/mageplaza/brand/quut.jpg","url_key":"quut","option_id":790,"is_featured":0},{"__typename":"MageplazaBrands","value":"Ravensburger","image":"https://do.baltbaby.com/media/mageplaza/brand/ravensburger_1.png","url_key":"ravensburger","option_id":952,"is_featured":0},{"__typename":"MageplazaBrands","value":"Relax Mom","image":"https://do.baltbaby.com/media/mageplaza/brand/relax-mom.png","url_key":"relax-mom","option_id":3505,"is_featured":0},{"__typename":"MageplazaBrands","value":"Rock My Sleep","image":"https://do.baltbaby.com/media/mageplaza/brand/rock_my_sleep_150.jpg","url_key":"rock-my-sleep","option_id":3961,"is_featured":0},{"__typename":"MageplazaBrands","value":"Rockit","image":"https://do.baltbaby.com/media/mageplaza/brand/rockit.jpg","url_key":"rockit","option_id":841,"is_featured":0},{"__typename":"MageplazaBrands","value":"Safety 1st","image":"https://do.baltbaby.com/media/mageplaza/brand/safety_1.png","url_key":"safety-1st","option_id":908,"is_featured":0},{"__typename":"MageplazaBrands","value":"Semper","image":"https://do.baltbaby.com/media/mageplaza/brand/semper.jpg","url_key":"semper","option_id":753,"is_featured":0},{"__typename":"MageplazaBrands","value":"SIPO","image":"https://do.baltbaby.com/media/mageplaza/brand/logo-SIPO.jpg","url_key":"sipo","option_id":4247,"is_featured":0},{"__typename":"MageplazaBrands","value":"Sleepytroll","image":"https://do.baltbaby.com/media/mageplaza/brand/Sleepytroll-Logo.png","url_key":"sleepytroll","option_id":807,"is_featured":0},{"__typename":"MageplazaBrands","value":"Small Foot","image":"https://do.baltbaby.com/media/mageplaza/brand/Small_Foot.png","url_key":"small-foot","option_id":3438,"is_featured":0},{"__typename":"MageplazaBrands","value":"SMART GAMES","image":"https://do.baltbaby.com/media/mageplaza/brand/Smart_Games_logo.jpg","url_key":"smart-games","option_id":4135,"is_featured":0},{"__typename":"MageplazaBrands","value":"SmartMax","image":"https://do.baltbaby.com/media/mageplaza/brand/SmartMax-2.png","url_key":"smartmax","option_id":4010,"is_featured":0},{"__typename":"MageplazaBrands","value":"Smoby","image":"https://do.baltbaby.com/media/mageplaza/brand/smoby_1.png","url_key":"smoby","option_id":948,"is_featured":0},{"__typename":"MageplazaBrands","value":"Softybag","image":"https://do.baltbaby.com/media/mageplaza/brand/3428_big.png","url_key":"softybag","option_id":3791,"is_featured":0},{"__typename":"MageplazaBrands","value":"Stanley Jr.","image":"https://do.baltbaby.com/media/mageplaza/brand/STANLEY_Jr.png","url_key":"stanley-jr","option_id":3453,"is_featured":0},{"__typename":"MageplazaBrands","value":"Stokke","image":"https://do.baltbaby.com/media/mageplaza/brand/logo_stokke.png","url_key":"stokke","option_id":3706,"is_featured":0},{"__typename":"MageplazaBrands","value":"Stoy","image":"https://do.baltbaby.com/media/mageplaza/brand/stoyuus.jpg","url_key":"stoy","option_id":754,"is_featured":0},{"__typename":"MageplazaBrands","value":"Strider","image":"https://do.baltbaby.com/media/mageplaza/brand/strider-stacked-logo_baltbaby.png","url_key":"strider","option_id":3343,"is_featured":0},{"__typename":"MageplazaBrands","value":"Suavinex","image":"https://do.baltbaby.com/media/mageplaza/brand/logo-suavinex.png","url_key":"suavinex","option_id":3784,"is_featured":0},{"__typename":"MageplazaBrands","value":"Tactic","image":"https://do.baltbaby.com/media/mageplaza/brand/tactic.jpg","url_key":"tactic","option_id":797,"is_featured":0},{"__typename":"MageplazaBrands","value":"Taf Toys","image":"https://do.baltbaby.com/media/mageplaza/brand/taftoys.png","url_key":"taf-toys","option_id":736,"is_featured":0},{"__typename":"MageplazaBrands","value":"Tega","image":"https://do.baltbaby.com/media/mageplaza/brand/tega_1.jpg","url_key":"tega","option_id":715,"is_featured":0},{"__typename":"MageplazaBrands","value":"TFK","image":"https://do.baltbaby.com/media/mageplaza/brand/logo--tablet.png","url_key":"tfk","option_id":3725,"is_featured":0},{"__typename":"MageplazaBrands","value":"The Jiffle","image":"https://do.baltbaby.com/media/mageplaza/brand/theJiffle.jpg","url_key":"the-jiffle","option_id":3681,"is_featured":0},{"__typename":"MageplazaBrands","value":"The Nice Fleet","image":"https://do.baltbaby.com/media/mageplaza/brand/the_nice_fleet_dark.png","url_key":"the-nice-fleet","option_id":3684,"is_featured":0},{"__typename":"MageplazaBrands","value":"The Zoofamily","image":"https://do.baltbaby.com/media/mageplaza/brand/The_zoofamily_logo.jpg","url_key":"the-zoofamily","option_id":4230,"is_featured":0},{"__typename":"MageplazaBrands","value":"Thule","image":"https://do.baltbaby.com/media/mageplaza/brand/thule_1.png","url_key":"thule","option_id":719,"is_featured":1},{"__typename":"MageplazaBrands","value":"Tidy Tot","image":"https://do.baltbaby.com/media/mageplaza/brand/tidytot.png","url_key":"tidy-tot","option_id":762,"is_featured":0},{"__typename":"MageplazaBrands","value":"Tikiri","image":"https://do.baltbaby.com/media/mageplaza/brand/tikiri.jpg","url_key":"tikiri","option_id":733,"is_featured":0},{"__typename":"MageplazaBrands","value":"Tommee Tippee","image":"https://do.baltbaby.com/media/mageplaza/brand/tommeetippee_1.png","url_key":"tommee-tippee","option_id":729,"is_featured":0},{"__typename":"MageplazaBrands","value":"Tomy","image":"https://do.baltbaby.com/media/mageplaza/brand/TOMY_blue_logo2.jpg","url_key":"tomy","option_id":4002,"is_featured":0},{"__typename":"MageplazaBrands","value":"Toys for Life","image":"https://do.baltbaby.com/media/mageplaza/brand/toysforlife.jpg","url_key":"toys-for-life","option_id":789,"is_featured":0},{"__typename":"MageplazaBrands","value":"Trixie","image":"https://do.baltbaby.com/media/mageplaza/brand/Red_and_Beige_Vintage_Bold_Typographic_Beauty_Salon_Logo.png","url_key":"trixie","option_id":4461,"is_featured":0},{"__typename":"MageplazaBrands","value":"Troll","image":"https://do.baltbaby.com/media/mageplaza/brand/Troll_logo.jpg","url_key":"troll","option_id":710,"is_featured":0},{"__typename":"MageplazaBrands","value":"TTS","image":"https://do.baltbaby.com/media/mageplaza/brand/tts_1.jpg","url_key":"tts","option_id":951,"is_featured":0},{"__typename":"MageplazaBrands","value":"Tuban","image":"https://do.baltbaby.com/media/mageplaza/brand/tuban-logo_baltbaby.jpg","url_key":"tuban","option_id":788,"is_featured":0},{"__typename":"MageplazaBrands","value":"Tullo","image":"https://do.baltbaby.com/media/mageplaza/brand/Tullo_logo.jpg","url_key":"tullo","option_id":4042,"is_featured":0},{"__typename":"MageplazaBrands","value":"Vaggaro","image":"https://do.baltbaby.com/media/mageplaza/brand/vaggaro.jpg","url_key":"vaggaro","option_id":842,"is_featured":0},{"__typename":"MageplazaBrands","value":"Valco Baby","image":"https://do.baltbaby.com/media/mageplaza/brand/logo_valco_baby.png","url_key":"valco-baby","option_id":3477,"is_featured":0},{"__typename":"MageplazaBrands","value":"Voksi","image":"https://do.baltbaby.com/media/mageplaza/brand/voksi2.png","url_key":"voksi","option_id":3584,"is_featured":0},{"__typename":"MageplazaBrands","value":"Waytoplay","image":"https://do.baltbaby.com/media/mageplaza/brand/waytoplay.jpg","url_key":"waytoplay","option_id":791,"is_featured":0},{"__typename":"MageplazaBrands","value":"We-Too","image":"https://do.baltbaby.com/media/mageplaza/brand/we_too_logo.png","url_key":"we-too","option_id":4307,"is_featured":0},{"__typename":"MageplazaBrands","value":"Wool In Love","image":"https://do.baltbaby.com/media/mageplaza/brand/woolinlove.png","url_key":"wool-in-love","option_id":820,"is_featured":0},{"__typename":"MageplazaBrands","value":"Wooly Organic","image":"https://do.baltbaby.com/media/mageplaza/brand/wooly_organic_logo.jpg","url_key":"wooly-organic","option_id":4157,"is_featured":0},{"__typename":"MageplazaBrands","value":"ZAZU","image":"https://do.baltbaby.com/media/mageplaza/brand/zazu_1.jpg","url_key":"zazu","option_id":777,"is_featured":0},{"__typename":"MageplazaBrands","value":"Zuze & Friends","image":"https://do.baltbaby.com/media/mageplaza/brand/zuze_1.jpg","url_key":"zuze-friends","option_id":830,"is_featured":0}]');
;// CONCATENATED MODULE: ./components/Product/Main/index.js
function Main_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Main_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Main_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Main_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Main_slicedToArray(arr, i) {
    return Main_arrayWithHoles(arr) || Main_iterableToArrayLimit(arr, i) || Main_unsupportedIterableToArray(arr, i) || Main_nonIterableRest();
}
function Main_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Main_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Main_arrayLikeToArray(o, minLen);
}





























function MainDetails(param1) {
    var product1 = param1.product;
    var ref26, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref3 = product1 || {}, media_gallery = ref3.media_gallery, rating_summary = ref3.rating_summary;
    var brand = product1 === null || product1 === void 0 ? void 0 : product1.mpbrand;
    var brandValues = (brand === null || brand === void 0 ? void 0 : brand.value) && (brand === null || brand === void 0 ? void 0 : brand.image);
    var configurableOptions = product1 === null || product1 === void 0 ? void 0 : product1.configurable_options;
    var ref4 = (0,react.useState)(null), stockStatus = ref4[0], setStockStatus = ref4[1];
    var ref5 = (0,react.useState)(false), inStock = ref5[0], setInStock = ref5[1];
    var ref6 = (0,react.useState)(null), deliveryTime = ref6[0], setDeliveryTime = ref6[1];
    var ref7 = (0,react.useState)(product1 === null || product1 === void 0 ? void 0 : product1.price_range), priceRange = ref7[0], setPriceRange = ref7[1];
    var ref8 = (0,react.useState)(false), variation = ref8[0], setVariation = ref8[1];
    var ref9 = Main_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productImagesAtom */.cj), 2), images = ref9[0], setImages = ref9[1];
    var ref10 = (0,react.useState)(), brandImage = ref10[0], setBrandImage = ref10[1];
    // Add new state for better stock tracking
    var ref11 = (0,react.useState)(product1 === null || product1 === void 0 ? void 0 : product1.sku), currentSku = ref11[0], setCurrentSku = ref11[1];
    var ref12 = (0,react.useState)(false), isCheckingStock = ref12[0], setIsCheckingStock = ref12[1];
    var ref13 = Main_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* productVariantsAtom */.CA), 2), selectedVariants = ref13[0], setSelectedVariants = ref13[1];
    var ref14 = Main_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* authAtom */.L4), 1), ref15 = ref14[0], isAuth = ref15.token;
    var ref16 = Main_slicedToArray((0,jotai_esm/* useAtom */.KO)(store/* addToCartErrorAtom */.z8), 1), error1 = ref16[0];
    var price = useProductPrice(priceRange);
    var ref17 = useColors(product1), showColors = ref17.showColors, colors = ref17.colors;
    var ref18 = (0,useAddToCart/* default */.Z)(product1), addToCart = ref18.addToCart, loading = ref18.loading;
    // Helper function to get the current active SKU
    var getCurrentSku = function() {
        if (!variation || !variation.sku) {
            return product1 === null || product1 === void 0 ? void 0 : product1.sku;
        }
        return variation.sku;
    };
    // Helper function to check if all required configurable options are selected
    var areAllOptionsSelected = function() {
        if (!configurableOptions || configurableOptions.length === 0) {
            return true; // Simple product, no options required
        }
        if (!selectedVariants || selectedVariants.length === 0) {
            return false; // No variants selected
        }
        // Check if the number of selected variants matches the number of configurable options
        var requiredOptionsCount = configurableOptions.length;
        var selectedOptionsCount = selectedVariants.length;
        return selectedOptionsCount === requiredOptionsCount;
    };
    (0,react.useEffect)(function() {
        if (brand && brand.option_id) {
            var brandID = brand.option_id;
            var index = brands_namespaceObject.findIndex(function(el) {
                return el.option_id === brandID;
            });
            if (index !== -1) {
                setBrandImage(brands_namespaceObject[index].image);
            } else {
                setBrandImage(brand.image);
            }
        }
    }, [
        brand
    ]);
    (0,react.useEffect)(function() {
        if ((selectedVariants === null || selectedVariants === void 0 ? void 0 : selectedVariants.length) > 0) {
            var variant;
            if ((configurableOptions === null || configurableOptions === void 0 ? void 0 : configurableOptions.length) > 1) {
                var ref27, ref19;
                variant = (ref19 = product1 === null || product1 === void 0 ? void 0 : (ref27 = product1.variants) === null || ref27 === void 0 ? void 0 : ref27.find(function(param) {
                    var attributes = param.attributes;
                    return attributes === null || attributes === void 0 ? void 0 : attributes.find(function(item) {
                        var ref;
                        return (item === null || item === void 0 ? void 0 : item.uid) === ((ref = selectedVariants[0]) === null || ref === void 0 ? void 0 : ref.uid);
                    });
                })) === null || ref19 === void 0 ? void 0 : ref19.product;
            } else {
                var ref20, ref21;
                variant = (ref21 = product1 === null || product1 === void 0 ? void 0 : (ref20 = product1.variants) === null || ref20 === void 0 ? void 0 : ref20.find(function(param) {
                    var product = param.product;
                    var ref;
                    return (product === null || product === void 0 ? void 0 : product.sku) === ((ref = selectedVariants[0]) === null || ref === void 0 ? void 0 : ref.sku);
                })) === null || ref21 === void 0 ? void 0 : ref21.product;
            }
            if (!variant) {
                var ref22;
                variant = product1 === null || product1 === void 0 ? void 0 : (ref22 = product1.variants) === null || ref22 === void 0 ? void 0 : ref22.find(function(param) {
                    var attributes = param.attributes;
                    return attributes === null || attributes === void 0 ? void 0 : attributes.find(function(item) {
                        var ref;
                        return (item === null || item === void 0 ? void 0 : item.uid) === ((ref = selectedVariants[0]) === null || ref === void 0 ? void 0 : ref.uid);
                    });
                });
                if (variant) {
                    variant = variant === null || variant === void 0 ? void 0 : variant.product;
                }
            }
            if (configurableOptions.length > 1 && selectedVariants.length > 1) {
                var filterValue = selectedVariants.map(function(obj) {
                    return obj.uid;
                });
                var options = Array.from(product1 === null || product1 === void 0 ? void 0 : product1.variants);
                var possibleOptions = options.filter(function(obj) {
                    return filterValue.every(function(uuid) {
                        return obj.attributes.some(function(valueObj) {
                            return valueObj.uid === uuid;
                        });
                    });
                });
                if (possibleOptions.length > 0) {
                    var ref23, ref24, ref25;
                    variant = (ref23 = possibleOptions[0]) === null || ref23 === void 0 ? void 0 : ref23.product;
                    setImages((ref24 = possibleOptions[0]) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.product) === null || ref25 === void 0 ? void 0 : ref25.media_gallery);
                }
            }
            variant && setPriceRange(variant === null || variant === void 0 ? void 0 : variant.price_range);
            variant && setVariation(variant);
        } else {
            setVariation(false);
        }
    }, [
        configurableOptions,
        selectedVariants
    ]);
    (0,react.useEffect)(function() {
        if ((selectedVariants === null || selectedVariants === void 0 ? void 0 : selectedVariants.length) === 0) {
            media_gallery && setImages(media_gallery);
            setPriceRange(product1 === null || product1 === void 0 ? void 0 : product1.price_range);
        }
    }, [
        media_gallery,
        selectedVariants
    ]);
    // Separate effect to track the current SKU
    (0,react.useEffect)(function() {
        var activeSku = getCurrentSku();
        setCurrentSku(activeSku);
    }, [
        variation,
        product1 === null || product1 === void 0 ? void 0 : product1.sku
    ]);
    // Use the stockStatus from StockStatus component to determine in stock and delivery time
    (0,react.useEffect)(function() {
        var ref, ref30;
        // For configurable products, check if all required options are selected
        if (configurableOptions && configurableOptions.length > 0) {
            if (!areAllOptionsSelected()) {
                setIsCheckingStock(false);
                setInStock(false);
                setDeliveryTime(null); // Clear delivery time when not all options selected
                return;
            }
        }
        if (!stockStatus) {
            setIsCheckingStock(true);
            return;
        }
        setIsCheckingStock(false);
        // Calculate total stock from both warehouses
        var kvartalQty = (stockStatus === null || stockStatus === void 0 ? void 0 : (ref = stockStatus.kvartal) === null || ref === void 0 ? void 0 : ref.qty) || 0;
        var warehouseQty = (stockStatus === null || stockStatus === void 0 ? void 0 : (ref30 = stockStatus.warehouse) === null || ref30 === void 0 ? void 0 : ref30.qty) || 0;
        var totalQty = kvartalQty + warehouseQty;
        var hasStock = totalQty > 0;
        setInStock(hasStock);
        if (!hasStock) {
            axios_default().post("/api/delivery-time", {
                sku: currentSku,
                skuMain: product1 === null || product1 === void 0 ? void 0 : product1.sku
            }).then(function(deliveryResponse) {
                var deliveryData = deliveryResponse.data;
                if (deliveryData && deliveryData !== "" && deliveryData !== null) {
                    setDeliveryTime(deliveryData);
                } else {
                    setDeliveryTime(null);
                }
            }).catch(function(error) {
                console.error("Error fetching delivery time:", error); // Debug log
                (0,minimal_esm/* captureException */.Tb)(error);
                setDeliveryTime(null);
            });
        } else {
            // Has stock, clear delivery time
            setDeliveryTime(null);
        }
    }, [
        stockStatus,
        currentSku,
        product1 === null || product1 === void 0 ? void 0 : product1.sku,
        configurableOptions,
        selectedVariants
    ]); // Add selectedVariants as dependency
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            return setSelectedVariants([]);
        };
        router.events.on("routeChangeStart", handleRouteChange);
        return function() {
            return router.events.off("routeChangeStart", handleRouteChange);
        };
    }, []);
    // Update the delivery time display logic
    var shouldShowDeliveryTime = !inStock && deliveryTime && !isCheckingStock && // Don't show delivery time if not all configurable options are selected
    areAllOptionsSelected();
    var shouldShowInStock = inStock && !isCheckingStock && // Don't show in stock if not all configurable options are selected
    areAllOptionsSelected();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                minWidth: 81,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider, {
                    images: images,
                    product: product1 === null || product1 === void 0 ? void 0 : product1.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInformation, {
                error: error1,
                children: [
                    brandValues && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/brands/".concat(brand === null || brand === void 0 ? void 0 : brand.url_key, "?id=").concat(brand === null || brand === void 0 ? void 0 : brand.option_id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "brand_logo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: brandImage,
                                alt: brand === null || brand === void 0 ? void 0 : brand.value,
                                layout: "fill",
                                objectFit: "contain"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                        as: "h1",
                        fontSize: "large",
                        pt: {
                            desktop: brandValues ? "3rem" : 0
                        },
                        pb: {
                            _: "1rem",
                            desktop: rating_summary > 0 ? "0.5rem" : "1rem"
                        },
                        children: product1 === null || product1 === void 0 ? void 0 : product1.name
                    }),
                    rating_summary > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                        spaceX: "0.75rem",
                        pb: {
                            _: "1.5rem",
                            desktop: "2rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Kasutajate hinnang: "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* default */.Z, {
                                rating: rating_summary,
                                spaceX: "0.25rem",
                                transform: "translateY(5%)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                        display: {
                            _: "block",
                            desktop: "none"
                        },
                        pb: "2rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSwiper, {
                                images: images,
                                product: product1 === null || product1 === void 0 ? void 0 : product1.name
                            }),
                            showColors && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwiper, {
                                variants: colors
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        display: {
                            _: "block",
                            desktop: "none"
                        },
                        children: configurableOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomOptions, {
                            product: product1
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(interweave_esm/* Markup */.Lu, {
                        content: product1 === null || product1 === void 0 ? void 0 : (ref26 = product1.short_description) === null || ref26 === void 0 ? void 0 : ref26.html,
                        tagName: "p"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StockStatus, {
                        id: product1 === null || product1 === void 0 ? void 0 : product1.id,
                        sku: product1 === null || product1 === void 0 ? void 0 : product1.sku,
                        stockStatus: stockStatus,
                        setStockStatus: setStockStatus,
                        product: product1
                    }),
                    (price === null || price === void 0 ? void 0 : price.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceInformation, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    t("product_main.current_price"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    price === null || price === void 0 ? void 0 : price.value
                                ]
                            }),
                            (price === null || price === void 0 ? void 0 : (ref1 = price.discount) === null || ref1 === void 0 ? void 0 : ref1.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                ml: "2rem",
                                children: [
                                    t("product_main.regular_price"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: price === null || price === void 0 ? void 0 : (ref2 = price.discount) === null || ref2 === void 0 ? void 0 : ref2.value
                                    })
                                ]
                            })
                        ]
                    }),
                    showColors && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                        display: {
                            _: "none",
                            desktop: "block"
                        },
                        pb: configurableOptions ? 0 : "2rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                children: [
                                    t("product_main.color_picker"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSlider, {
                                variants: colors
                            })
                        ]
                    }),
                    configurableOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        display: {
                            _: "none",
                            desktop: "block"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomOptions, {
                            product: product1
                        })
                    }),
                    shouldShowDeliveryTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                        align: "center",
                        spaceX: "1rem",
                        pb: "2rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                role: "img",
                                "aria-label": "Delivery truck icon",
                                children: SingleProduct/* DeliveryTruck */.ei
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    t("product_main.delivery_time"),
                                    ": ",
                                    deliveryTime,
                                    " ",
                                    t("product_main.days")
                                ]
                            })
                        ]
                    }),
                    shouldShowInStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("product_main.in_stock")
                    }),
                    isCheckingStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Checking availability..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexColCenter */.S, {
                        maxW: 400,
                        align: {
                            _: "flex-start",
                            desktop: "center"
                        },
                        ml: {
                            _: 0,
                            desktop: "-3rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary/* default */.Z, {
                                w: "80%",
                                py: "0.5rem",
                                mb: {
                                    _: "1rem",
                                    desktop: "1.5rem"
                                },
                                onClick: addToCart,
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : t("product_main.basket_add")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                                spaceX: "1rem",
                                children: isAuth && /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite, {
                                    product: product1
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Product/Tabs.js
function Tabs_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Tabs_templateObject() {
    var data = Tabs_taggedTemplateLiteral([
        "\n  margin-bottom: 6rem;\n\n  @media (max-width: desktop) {\n    margin-bottom: 3.5rem;\n    padding: 2rem 1rem 0;\n  }\n"
    ]);
    Tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tabs_templateObject1() {
    var data = Tabs_taggedTemplateLiteral([
        "\n  padding-top: 2rem;\n\n  h3 {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  p {\n    max-width: 900px;\n    line-height: 1.75;\n  }\n\n  ul {\n    list-style-type: disc;\n\n    @media (max-width: desktop) {\n      padding-left: 1rem;\n    }\n  }\n\n  ol {\n    list-style-type: decimal;\n  }\n\n  a.brand_logo {\n    @media (min-width: desktop) {\n      display: none;\n    }\n  }\n  a {\n    text-decoration: underline;\n    color: #54c8e6;\n  }\n"
    ]);
    Tabs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Tabs_templateObject2() {
    var data = Tabs_taggedTemplateLiteral([
        "\n      &::after {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 2rem;\n        width: 85px;\n        height: 6px;\n        background-color: teal-100;\n      }\n    "
    ]);
    Tabs_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Tabs_templateObject3() {
    var data = Tabs_taggedTemplateLiteral([
        "\n  position: relative;\n  font-weight: 700;\n\n  ",
        "\n"
    ]);
    Tabs_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var Tabs = styled_components_esm/* default.section */.ZPm.section(Tabs_templateObject());
var Tab = styled_components_esm/* default.div */.ZPm.div(Tabs_templateObject1());
var TabButton = (0,styled_components_esm/* default */.ZPm)(Button/* default */.Z)(Tabs_templateObject3(), function(param) {
    var selected = param.selected;
    return selected && (0,styled_components_esm/* css */.ivY)(Tabs_templateObject2());
});
function ProductTabs(param) {
    var description = param.description, brand = param.brand;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(description ? 1 : 2), selectedTab = ref[0], setSelectedTab = ref[1];
    var transformDescription = function(node) {
        if (node.innerHTML === "\xdcldinfo") return null;
        if (node.innerHTML === "General information") return null;
    };
    var brandValues = (brand === null || brand === void 0 ? void 0 : brand.value) && (brand === null || brand === void 0 ? void 0 : brand.image);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs, {
        children: [
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabButton, {
                selected: selectedTab === 1,
                onClick: function() {
                    return setSelectedTab(1);
                },
                p: "0 4rem 0 0",
                children: t("product_main.general")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabButton, {
                selected: selectedTab === 2,
                onClick: function() {
                    return setSelectedTab(2);
                },
                p: "0",
                children: t("product_main.pay_installments")
            }),
            selectedTab === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab, {
                children: [
                    brandValues && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/brands/".concat(brand === null || brand === void 0 ? void 0 : brand.url_key, "?id=").concat(brand === null || brand === void 0 ? void 0 : brand.option_id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "brand_logo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: brand === null || brand === void 0 ? void 0 : brand.image,
                                alt: brand === null || brand === void 0 ? void 0 : brand.value,
                                width: 100,
                                height: 100,
                                objectFit: "contain"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(interweave_esm/* Markup */.Lu, {
                        tagName: "div",
                        content: description,
                        transform: transformDescription
                    })
                ]
            }),
            selectedTab === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                        mt: 16,
                        mb: 16,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                children: [
                                    " ",
                                    t("product_main.ESTO_installments")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                                spaceY: 16,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    t("product_main.pay_later"),
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            t("product_main.buy_now")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    t("product_main.ESTO_3_TITLE"),
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            t("product_main.ESTO_3")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    t("product_main.pay_installments"),
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            t("product_main.installments_option_subtext")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: t("product_main.liisi_installments")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        as: "p",
                        maxW: 600,
                        children: t("product_main.liisi_installments_subtext")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                        as: "p",
                        mt: 16,
                        children: [
                            t("product_main.read_more"),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                                as: "a",
                                fontWeight: 700,
                                href: "https://holmbank.ee/jarelmaks",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: t("product_main.holmbank")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/UI/useModal.js
var useModal = __webpack_require__(1642);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
// EXTERNAL MODULE: ./graphql/mutations/index.js + 30 modules
var mutations = __webpack_require__(9592);
;// CONCATENATED MODULE: ./hooks/products/useReview.js
function useReview_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useReview_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useReview_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useReview_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useReview_slicedToArray(arr, i) {
    return useReview_arrayWithHoles(arr) || useReview_iterableToArrayLimit(arr, i) || useReview_unsupportedIterableToArray(arr, i) || useReview_nonIterableRest();
}
function useReview_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useReview_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useReview_arrayLikeToArray(o, minLen);
}



function useReview(rating, sku) {
    var ref = useReview_slicedToArray((0,useMutation/* useMutation */.D)(mutations/* CREATE_PRODUCT_REVIEW */.UO), 2), addReview = ref[0], ref1 = ref[1], data1 = ref1.data, loading = ref1.loading;
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var value;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.t0 = rating;
                        _ctx.next = _ctx.t0 === 1 ? 4 : _ctx.t0 === 2 ? 6 : _ctx.t0 === 3 ? 8 : _ctx.t0 === 4 ? 10 : _ctx.t0 === 5 ? 12 : 14;
                        break;
                    case 4:
                        value = "MTY=";
                        return _ctx.abrupt("break", 14);
                    case 6:
                        value = "MTc=";
                        return _ctx.abrupt("break", 14);
                    case 8:
                        value = "MTg=";
                        return _ctx.abrupt("break", 14);
                    case 10:
                        value = "MTk=";
                        return _ctx.abrupt("break", 14);
                    case 12:
                        value = "MjA=";
                        return _ctx.abrupt("break", 14);
                    case 14:
                        _ctx.next = 16;
                        return addReview({
                            variables: {
                                sku: sku,
                                nickname: data === null || data === void 0 ? void 0 : data.reviewer,
                                text: data === null || data === void 0 ? void 0 : data.comment,
                                value: value
                            }
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        onSubmit: onSubmit,
        data: data1,
        loading: loading
    };
};

// EXTERNAL MODULE: ./components/UI/Modal/index.js
var Modal = __webpack_require__(9968);
// EXTERNAL MODULE: ./components/UI/Form/Input.js
var Input = __webpack_require__(2979);
// EXTERNAL MODULE: ./components/UI/Form/Textarea.js
var Textarea = __webpack_require__(7115);
// EXTERNAL MODULE: ./components/UI/Ratings/RatingScale.js
var RatingScale = __webpack_require__(4806);
;// CONCATENATED MODULE: ./components/Modals/Rating.js
function Rating_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Rating_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Rating_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













function RatingModal(param) {
    var product = param.product, isShown = param.isShown, toggle = param.toggle;
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors;
    var ref1 = (0,react.useState)(null), rating = ref1[0], setRating = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = useReview(rating, product === null || product === void 0 ? void 0 : product.sku), onSubmit = ref3.onSubmit, data = ref3.data, loading = ref3.loading;
    // Set error when no rating added
    (0,react.useEffect)(function() {
        if (isSubmitting && !rating) {
            setError("Hinnang on kohustuslik");
        } else if (rating) {
            setError(null);
        }
    }, [
        isSubmitting,
        rating
    ]);
    // Close modal on successful submit & show toast
    (0,react.useEffect)(function() {
        if (data) {
            newRatingAddedToast({
                isDesktop: viewportWidth >= 1024
            });
            toggle();
        }
    }, [
        data
    ]);
    var modalContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
        as: "form",
        dir: "column",
        align: "center",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                textAlign: "center",
                fontSize: {
                    _: "large",
                    sm_tablet: "xlarge"
                },
                pt: "0.75rem",
                pb: "2rem",
                children: product === null || product === void 0 ? void 0 : product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                fontSize: {
                    _: "small",
                    sm_tablet: "medium"
                },
                children: "Hinnang tootele:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingScale/* default */.Z, {
                rating: rating,
                setRating: setRating,
                error: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                dir: "column",
                spaceY: "1.5rem",
                alignSelf: "flex-start",
                w: "100%",
                mt: "1.75rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, Rating_objectSpread({}, register("reviewer", {
                        required: "Kohustuslik v\xe4li"
                    }), {
                        placeholder: "Nimi",
                        error: errors === null || errors === void 0 ? void 0 : errors.reviewer,
                        w: {
                            _: "100%",
                            tablet: "350px"
                        },
                        borderRadius: "7px"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* default */.Z, Rating_objectSpread({}, register("comment", {
                        required: "Kohustuslik v\xe4li"
                    }), {
                        placeholder: "Kommentaar",
                        error: errors.comment,
                        w: "100%",
                        borderWidth: "1px"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary/* default */.Z, {
                type: "submit",
                p: "0.5rem",
                w: {
                    _: "220px",
                    desktop: "40%"
                },
                mt: "2.5rem",
                children: isSubmitting || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : "Lisa kommentaar"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, {
        isShown: isShown,
        hide: toggle,
        content: modalContent,
        width: {
            _: "90vw",
            tablet: "500px",
            desktop: "790px"
        },
        p: {
            _: "2.5rem 1rem",
            sm_tablet: "3rem 2rem",
            desktop: "3rem 6rem"
        }
    });
};

;// CONCATENATED MODULE: ./components/Product/Reviews.js
function Reviews_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Reviews_templateObject() {
    var data = Reviews_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 720px;\n  margin-bottom: 5rem;\n\n  p {\n    font-weight: 600;\n  }\n\n  button {\n    align-self: center;\n  }\n\n  @media (max-width: desktop) {\n    padding: 0 1rem;\n    margin-bottom: 5rem;\n  }\n"
    ]);
    Reviews_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var RatingsContainer = styled_components_esm/* default.section */.ZPm.section(Reviews_templateObject());
function Reviews(param) {
    var product = param.product;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,styled_components_esm/* useTheme */.FgM)();
    var ref1 = (0,useModal/* default */.Z)(), isShown = ref1.isShown, toggle = ref1.toggle;
    var reviews = product === null || product === void 0 ? void 0 : (ref = product.reviews) === null || ref === void 0 ? void 0 : ref.items;
    var ref2 = (0,react.useState)(2), reviewsShown = ref2[0], setReviewsShown = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            t("review.comments"),
                            " (",
                            reviews === null || reviews === void 0 ? void 0 : reviews.length,
                            ")"
                        ]
                    }),
                    (reviews === null || reviews === void 0 ? void 0 : reviews.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        pt: {
                            _: "1.5rem",
                            desktop: "4rem"
                        },
                        pb: "3rem",
                        children: reviews === null || reviews === void 0 ? void 0 : reviews.slice(0, reviewsShown).map(function(review, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                                pt: {
                                    _: i > 0 && "3rem",
                                    desktop: i > 0 && "6rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                        align: "center",
                                        justify: "space-between",
                                        pb: {
                                            _: "1rem",
                                            desktop: "2rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: review.nickname
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                                as: "span",
                                                spaceX: "0.75rem",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            t("review.review"),
                                                            ":"
                                                        ]
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* default */.Z, {
                                                        rating: review.average_rating,
                                                        spaceX: "0.25rem",
                                                        transform: "translateY(5%)"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                                        as: "p",
                                        lineHeight: "1.75",
                                        children: review.text
                                    })
                                ]
                            }, i);
                        })
                    }),
                    (reviews === null || reviews === void 0 ? void 0 : reviews.length) > reviewsShown && reviewsShown !== (reviews === null || reviews === void 0 ? void 0 : reviews.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mb: "2rem",
                        hoverColor: "gray-200",
                        textDecoration: "underline",
                        onClick: function() {
                            return setReviewsShown(reviewsShown + 2);
                        },
                        children: t("review.show_more")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: toggle,
                        mt: (reviews === null || reviews === void 0 ? void 0 : reviews.length) === 0 && 24,
                        alignSelf: (reviews === null || reviews === void 0 ? void 0 : reviews.length) === 0 && "flex-start",
                        p: "0.5rem 3rem",
                        color: "teal-100",
                        hoverColor: "teal-300",
                        border: "1px solid ".concat(theme.colors["teal-100"]),
                        hoverBorder: "1px solid ".concat(theme.colors["teal-300"]),
                        children: t("review.add_comment")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingModal, {
                product: product,
                isShown: isShown,
                toggle: toggle
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Catalogue/styles.js
var styles = __webpack_require__(3862);
// EXTERNAL MODULE: ./components/Catalogue/Products.js
var Products = __webpack_require__(2792);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3359);
;// CONCATENATED MODULE: ./pages/toode/[toode].js
function _toode_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _toode_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _toode_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                _toode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                _toode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _toode_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toode_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _toode_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toode_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _toode_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toode_slicedToArray(arr, i) {
    return _toode_arrayWithHoles(arr) || _toode_iterableToArrayLimit(arr, i) || _toode_unsupportedIterableToArray(arr, i) || _toode_nonIterableRest();
}
function _toode_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _toode_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _toode_arrayLikeToArray(o, minLen);
}






// import getProductImage from 'utils/getProductImage';














var __N_SSP = true;
function ProductPage(param) {
    var product = param.product, categories = param.categories, error = param.error, locale = param.locale, urlKey = param.urlKey;
    var ref14, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref9 = (0,react.useState)([]), relatedProducts = ref9[0], setRelatedProducts = ref9[1];
    var ref10 = _toode_slicedToArray((0,useLazyQuery/* useLazyQuery */.t)(queries/* RELATED_PRODUCTS */.r1, {
        variables: {
            urlKey: urlKey
        },
        context: {
            headers: {
                store: locale
            },
            fetchOptions: {
                method: "GET"
            }
        }
    }), 2), getRelatedProducts = ref10[0], ref11 = ref10[1], data = ref11.data, loading = ref11.loading;
    // FETCH RELATED PRODUCTS - Fixed to update when urlKey changes
    (0,react.useEffect)(function() {
        var fetchRelatedProducts = function() {
            var _ref = _toode_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref12, ref13, related;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            // Clear previous related products when navigating to new product
                            setRelatedProducts([]);
                            _ctx.next = 5;
                            return getRelatedProducts({
                                variables: {
                                    urlKey: urlKey
                                },
                                context: {
                                    headers: {
                                        store: locale
                                    },
                                    fetchOptions: {
                                        method: "GET"
                                    }
                                }
                            });
                        case 5:
                            related = _ctx.sent;
                            setRelatedProducts(((ref13 = related === null || related === void 0 ? void 0 : (ref = related.data) === null || ref === void 0 ? void 0 : (ref12 = ref.products) === null || ref12 === void 0 ? void 0 : ref12.items[0]) === null || ref13 === void 0 ? void 0 : ref13.related_products) || []);
                            _ctx.next = 13;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error("Error fetching related products:", _ctx.t0);
                            setRelatedProducts([]);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }));
            return function fetchRelatedProducts() {
                return _ref.apply(this, arguments);
            };
        }();
        if (urlKey) {
            fetchRelatedProducts();
        }
    }, [
        urlKey,
        locale,
        getRelatedProducts
    ]); // Added dependencies
    // Facebook Pixel tracking
    (0,react.useEffect)(function() {
        if (product) {
            var ref, ref15, ref16, ref17;
            var categoryName = (product === null || product === void 0 ? void 0 : product.categories) && product.categories.length > 0 ? (ref = product.categories[product.categories.length - 1]) === null || ref === void 0 ? void 0 : ref.name : "Unknown";
            fbq("track", "ViewContent", {
                content_type: "product",
                content_ids: [
                    product === null || product === void 0 ? void 0 : product.id
                ],
                content_name: product === null || product === void 0 ? void 0 : product.name,
                content_category: categoryName,
                value: product === null || product === void 0 ? void 0 : (ref15 = product.price_range) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.maximum_price) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.final_price) === null || ref17 === void 0 ? void 0 : ref17.value,
                currency: "EUR"
            });
        }
    }, [
        product
    ]);
    var router = (0,next_router.useRouter)();
    var breadcrumbs = useProductBreadcrumbs(product);
    var description = product === null || product === void 0 ? void 0 : (ref14 = product.short_description) === null || ref14 === void 0 ? void 0 : (ref1 = ref14.html) === null || ref1 === void 0 ? void 0 : ref1.replace(/<(.|\n)*?>/g, "");
    /* const image = getProductImage({
    mainImage: product?.image,
    gallery: product?.media_gallery
  }); */ // Google Analytics tracking
    (0,react.useEffect)(function() {
        if (product) viewProductEvent(product); // Send product view event to Google Analytics
    }, [
        product
    ]);
    // Redirect on error
    (0,react.useEffect)(function() {
        if (error) {
            router.push("/");
        }
    }, [
        error,
        router
    ]);
    if (error) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        categories: categories,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                seo: _toode_objectSpread({
                    title: "".concat(product === null || product === void 0 ? void 0 : product.name, " - Baltbaby"),
                    description: description
                }, (product === null || product === void 0 ? void 0 : (ref2 = product.image) === null || ref2 === void 0 ? void 0 : ref2.url) ? {
                    image: product === null || product === void 0 ? void 0 : (ref3 = product.image) === null || ref3 === void 0 ? void 0 : ref3.url
                } : null)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "application/ld+json",
                id: "baltbaby_product_structured_data",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(_toode_objectSpread({
                        "@context": "http://schema.org",
                        "@type": "Product",
                        name: product === null || product === void 0 ? void 0 : product.name,
                        sku: product === null || product === void 0 ? void 0 : product.sku,
                        image: product.image ? product.image.url : null
                    }, description ? {
                        description: description
                    } : null, (product === null || product === void 0 ? void 0 : (ref4 = product.mpbrand) === null || ref4 === void 0 ? void 0 : ref4.value) ? {
                        brand: {
                            "@type": "Brand",
                            name: product === null || product === void 0 ? void 0 : (ref5 = product.mpbrand) === null || ref5 === void 0 ? void 0 : ref5.value
                        }
                    } : null, {
                        offers: {
                            "@type": "Offer",
                            url: "https://baltbaby.com".concat(router.asPath),
                            priceCurrency: "EUR",
                            price: product === null || product === void 0 ? void 0 : (ref6 = product.price_range) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.minimum_price) === null || ref7 === void 0 ? void 0 : ref7.final_price.value
                        }
                    }))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                        crumbs: breadcrumbs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainDetails, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabs, {
                        description: product === null || product === void 0 ? void 0 : (ref8 = product.description) === null || ref8 === void 0 ? void 0 : ref8.html,
                        brand: product === null || product === void 0 ? void 0 : product.mpbrand
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                        product: product
                    }),
                    (relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                                as: "h2",
                                fontSize: "large",
                                pt: {
                                    desktop: "rem"
                                },
                                pb: {
                                    _: "1rem",
                                    desktop: "0.5rem"
                                },
                                children: t("product_main.related")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CatalogueContainer */.F, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ResultsContainer */.O, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Products/* default */.Z, {
                                        products: relatedProducts
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 4244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCategoryId; }
/* harmony export */ });
/* harmony import */ var global_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6863);

function getCategoryId(slug) {
    var category1 = global_data__WEBPACK_IMPORTED_MODULE_0__/* .categories.find */ .bd.find(function(category) {
        return category.url_key === slug;
    });
    var id = category1 === null || category1 === void 0 ? void 0 : category1.id.toString();
    return id;
};


/***/ }),

/***/ 8609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonproductimage":"Skeleton_skeletonproductimage__iedNz","skeletontitle":"Skeleton_skeletontitle__mmij2","skeletontext":"Skeleton_skeletontext__BMljH","mobileskeletonimage":"Skeleton_mobileskeletonimage__LE2pX","mobileskeletontitle":"Skeleton_mobileskeletontitle__uG6xV","mobileskeletontext":"Skeleton_mobileskeletontext__DK8qh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4337,1664,7536,9669,5675,3305,9447,5230,3108,40,9176,2483,5275,1979,9085,8435,1459,9774,2888,179], function() { return __webpack_exec__(2627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);